"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[942],{

/***/ 48761:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(50959);
var lib = __webpack_require__(53512);
var utils = __webpack_require__(28152);
var hooks = __webpack_require__(79923);
var definitions = __webpack_require__(25570);
var env = __webpack_require__(17434);
var styleInject_es = __webpack_require__(83114);
__webpack_require__(24774);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css_248z = ".Scrollable {\n  display: flex;\n  flex: 1 1 auto;\n  overflow: hidden;\n  max-width: 100%; /* Needed by IE11 */\n}\n\n.Scrollable--y-scroll {\n  flex-direction: column;\n}\n\n.Scrollable > * {\n  flex-shrink: 0; /* Needed by IE11 */\n}\n\n.Scrollable--x-scroll > * {\n  min-width: min-content; /* https://stackoverflow.com/questions/21515042/#answer-21541021 (probably only needed for y-scroll) */\n}\n\n.Scrollable--y-scroll > * {\n  min-height: min-content; /* https://stackoverflow.com/questions/21515042/#answer-21541021 */\n}\n\n.Scrollable--native-x-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Solves https://stackoverflow.com/questions/30574110/ */\n.Scrollable--native-x-scroll.Scrollable--mobile-safari {\n  overflow-x: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n\n.Scrollable--native-y-scroll {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n";
styleInject_es.styleInject(css_248z);

// ESLint is too dumb to see that the switch cases are exhaustive
const nativeSmoothScrollSupported = !(env.isInternetExplorer || env.isSafari);
const directionToOffsetName = {
    [definitions.Axis.X]: 'left',
    [definitions.Axis.Y]: 'top',
};
function getScrollPosition(direction, el) {
    switch (direction) {
        case definitions.Axis.X:
            return el.scrollLeft;
        case definitions.Axis.Y:
            return el.scrollTop;
        default:
            throw new Error('Unknown scroll axis');
    }
}
function getContainerSize(direction, el) {
    switch (direction) {
        case definitions.Axis.X:
            return el.offsetWidth;
        case definitions.Axis.Y:
            return el.offsetHeight;
        default:
            throw new Error('Unknown container size');
    }
}
function getContentSize(direction, el) {
    switch (direction) {
        case definitions.Axis.X:
            return el.scrollWidth;
        case definitions.Axis.Y:
            return el.scrollHeight;
        default:
            throw new Error('Unknown container size');
    }
}
function getMaxScrollPosition(direction, el) {
    return getContentSize(direction, el) - getContainerSize(direction, el);
}
function getScrollData(direction, el) {
    return {
        position: getScrollPosition(direction, el),
        maxPosition: getMaxScrollPosition(direction, el),
    };
}
function smoothScrollTo(direction, speed, el, position, animationFrameRequestIdRef) {
    const targetPosition = utils.clamp(position, 0, getMaxScrollPosition(direction, el));
    if (nativeSmoothScrollSupported) {
        const offsetName = directionToOffsetName[direction];
        el.scrollTo({
            [offsetName]: targetPosition,
            behavior: 'smooth',
        });
        return;
    }
    if (animationFrameRequestIdRef.current !== undefined) {
        cancelAnimationFrame(animationFrameRequestIdRef.current);
    }
    const startTime = performance.now();
    const startPosition = getScrollPosition(direction, el);
    const duration = definitions.speedToDurationMs[speed];
    (function step(now) {
        /* eslint-disable no-param-reassign */
        const fracTime = utils.clamp((now - startTime) / duration, 0, 1);
        const newPosition = utils.smoothstep(fracTime, startPosition, targetPosition);
        switch (direction) {
            case definitions.Axis.X: {
                el.scrollLeft = newPosition;
                break;
            }
            case definitions.Axis.Y: {
                el.scrollTop = newPosition;
                break;
            }
        }
        if (fracTime < 1) {
            animationFrameRequestIdRef.current = requestAnimationFrame(step);
        }
    })(startTime);
}
const name = 'Scrollable';
/**
 * Trait component that creates a viewport in which overflowing child content is scrollable in either X or Y direction.
 *
 * This component is a hybrid controlled/uncontrolled component. It has a controlled targetPosition
 * property, which signifies the desired scroll position. When the nativeScroll property is false,
 * the targetPosition will almost always match the actual scroll position, effectively making the
 * component fully controlled. If nativeScroll is true however, the user can interact with the
 * scrollable content and change the actual scroll position. This will trigger the onScroll
 * callback, which gives the controlling component the possibility to (conditionally) block
 * scrolling. The last (and often most useful) option is for the controlling component to react
 * to onScroll callbacks and update its own target scroll position.
 */
const Scrollable = ({ container = 'div', direction = definitions.Axis.X, nativeScroll = false, targetPosition = undefined, speed = definitions.Speed.Fast, onInit = definitions.noop, children, containerProps, className, variant, }) => {
    const props = { className, variant };
    const containerRef = React.useRef(null);
    const animationFrameRequestIdRef = React.useRef();
    const onScroll = React.useCallback(() => {
        if (containerRef.current && props.direction && props.onScroll) {
            props.onScroll(getScrollData(props.direction, containerRef.current));
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.onScroll, props.direction, containerRef.current]);
    React.useEffect(() => {
        if (targetPosition !== undefined) {
            smoothScrollTo(direction, speed, containerRef.current, targetPosition, animationFrameRequestIdRef);
        }
        if (onInit && containerRef.current) {
            onInit(getScrollData(direction, containerRef.current));
        }
        const animationFrameRequestId = animationFrameRequestIdRef.current;
        return () => {
            if (animationFrameRequestId !== undefined) {
                cancelAnimationFrame(animationFrameRequestId);
            }
        };
    }, [direction, onInit, speed, targetPosition]);
    const prevTargetPosition = hooks.usePrevious(targetPosition);
    React.useEffect(() => {
        if (targetPosition !== undefined && targetPosition !== prevTargetPosition) {
            smoothScrollTo(direction, speed, containerRef.current, targetPosition, animationFrameRequestIdRef);
        }
    });
    const Container = container;
    return (React__default["default"].createElement(Container, Object.assign({}, containerProps, { className: lib.classNames(name, props, `${name}--${direction}-scroll`, nativeScroll && `${name}--native-${direction}-scroll`, env.isSafari && env.hasTouchSupport && `${name}--mobile-safari`), ref: containerRef, onScroll: onScroll }), children));
};

exports.Scrollable = Scrollable;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68585:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(50959);
var text_variants = __webpack_require__(69346);
var icon_chevronUp_index = __webpack_require__(48436);
var scrollable_index = __webpack_require__(48761);
var lightThemeColors = __webpack_require__(24774);
var measurements = __webpack_require__(70416);
var styled = __webpack_require__(71993);
var definitions = __webpack_require__(25570);
var button_variants = __webpack_require__(71309);
var text_index = __webpack_require__(27562);
__webpack_require__(53512);
__webpack_require__(19803);
__webpack_require__(61217);
__webpack_require__(28152);
__webpack_require__(17434);
__webpack_require__(79923);
__webpack_require__(83114);
__webpack_require__(91661);
__webpack_require__(80677);
__webpack_require__(30294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const GAP = measurements.spacing100;
const ITEM_HEIGHT = '80px';
const Wrapper = styled__default["default"].div.withConfig({ displayName: "Wrapper", componentId: "-1erjqvs" }) `
  display: flex;
  flex-wrap: nowrap;
  gap: ${GAP};
  padding: 8px 0 12px 0; // Make room for box-shadow

  ${(p) => p.mobile &&
    styled.css `
      @media ${definitions.breakpoints.largeUp} {
        display: none;
      }
    `}
  ${(p) => p.desktop &&
    styled.css `
      @media ${definitions.breakpoints.mediumDown} {
        display: none;
      }
    `}
`;
const ListItem = styled__default["default"].li.withConfig({ displayName: "ListItem", componentId: "-1kx2001" }) `
  border: 1px solid ${lightThemeColors.base200};
  border-radius: 8px;
  height: ${ITEM_HEIGHT};

  a {
    text-decoration: none;
  }

  transition: box-shadow 200ms ease;

  &:hover {
    box-shadow: ${definitions.shadows.high};
  }
`;
const LinkWrapper = styled__default["default"].div.withConfig({ displayName: "LinkWrapper", componentId: "-tm4gzg" }) `
  gap: ${measurements.spacing100};
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  cursor: pointer;

  padding: ${measurements.spacing075};
  ${(p) => !p.$hasImage &&
    styled.css `
      padding-left: ${measurements.spacing125};
      padding-right: ${measurements.spacing125};
    `}
`;
const List = styled__default["default"].ul.withConfig({ displayName: "List", componentId: "-1vu7afb" })((p) => {
    var _a;
    const nbrOfColumns = p.$nbrOfLinks === 1 ? 1 : p.$linksPerRow;
    const horizontallyScrollable = p.$compact && ((_a = p.$nbrOfLinks) !== null && _a !== void 0 ? _a : 0) > 1;
    return styled.css `
    display: grid;
    grid-template-columns: repeat(${nbrOfColumns}, 1fr);
    grid-template-rows: 80px;
    flex-grow: 1;
    color: green;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: ${GAP};

    @media ${definitions.breakpoints.mediumDown} {
      gap: ${measurements.spacing050};

      ${horizontallyScrollable &&
        styled.css `
        display: flex;
        ${ListItem} {
          @media ${definitions.breakpoints.mediumDown} {
            width: 214px;
          }
        }
      `}

      ${!p.$compact &&
        styled.css `
        grid-template-columns: 1fr;
      `}
    }
  `;
});
const ImageWrapper = styled__default["default"].div.withConfig({ displayName: "ImageWrapper", componentId: "-rwdod8" }) `
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    max-width: 100%;
    max-height: 100%;
  }
`;
const ExpandButton = styled__default["default"](button_variants.OutlinedButton).withConfig({ displayName: "ExpandButton", componentId: "-1fjxu7y" }) `
  width: 80px;
  height: ${ITEM_HEIGHT};
  flex-shrink: 0;
`;
const Title = styled__default["default"](text_variants.TitleSmallText).withConfig({ displayName: "Title", componentId: "-vy3cg6" }) `
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

const VisualNavigation = ({ children, linksPerRow = 4, compact = true, className, style, }) => {
    const [expanded, setExpanded] = React.useState(false);
    const links = Array.isArray(children) ? children : [children];
    if (!links) {
        return null;
    }
    const nbrOfShownLinks = expanded ? links.length : linksPerRow;
    const nbrOfRemainingLinks = links.length - linksPerRow;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Wrapper, { className: className, style: style, mobile: true },
            React__default["default"].createElement(scrollable_index.Scrollable, { nativeScroll: true },
                React__default["default"].createElement(List, { "$linksPerRow": linksPerRow, "$compact": compact, "$nbrOfLinks": links.length }, links))),
        React__default["default"].createElement(Wrapper, { className: className, style: style, desktop: true },
            React__default["default"].createElement(List, { "$linksPerRow": linksPerRow }, compact ? links.slice(0, nbrOfShownLinks) : links),
            compact && links.length > linksPerRow && (React__default["default"].createElement(ExpandButton, { onClick: () => {
                    setExpanded(!expanded);
                } }, expanded ? (React__default["default"].createElement(icon_chevronUp_index.IconChevronUp, { size: 20 })) : (React__default["default"].createElement(text_variants.BodySmallText, null,
                "+",
                nbrOfRemainingLinks)))))));
};

function VisualNavigationLink({ label, url, imageSrc, imageAlt, ariaLabel, containerProps, linkContainer = 'a', linkContainerProps, style, className, }) {
    const hasImage = Boolean(imageSrc);
    const linkContent = (React__default["default"].createElement(LinkWrapper, { "$hasImage": hasImage },
        hasImage && (React__default["default"].createElement(ImageWrapper, null,
            React__default["default"].createElement("img", { src: imageSrc, alt: imageAlt }))),
        React__default["default"].createElement(Title, { color: text_index.FontColor.DARK }, label)));
    return (React__default["default"].createElement(ListItem, Object.assign({}, containerProps, { className: className, style: style }),
        React__default["default"].createElement(Link, Object.assign({ href: url, "aria-label": ariaLabel, as: linkContainer }, linkContainerProps), linkContent)));
}
const Link = styled__default["default"].a.withConfig({ displayName: "Link", componentId: "-ircgvv" }) ``;

exports.rH = VisualNavigation;
exports.Kr = VisualNavigationLink;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 53501:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ campaign_group)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(83018);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(69346);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(22486);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(65208);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  border-color: ",
        ";\n  border-style: solid;\n  border-width: 1px;\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CampaignListItem = (0,styled_components_browser_esm["default"])(list_variants.GridColumn).withConfig({
    displayName: "CampaignListItem",
    componentId: "sc-0-0"
})(_templateObject(), base/* colors.borderLightGray */.O9.borderLightGray, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RowWithWrap = (0,styled_components_browser_esm["default"])(list_variants.GridRow).withConfig({
    displayName: "RowWithWrap",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/index.js








var CampaignGroup = function(param) {
    var campaigns = param.campaigns, title = param.title, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!(campaigns === null || campaigns === void 0 ? void 0 : campaigns.length)) return null;
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
        className: className
    }, title && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, title), /*#__PURE__*/ react.createElement(RowWithWrap, null, campaigns.map(function(campaign) {
        return /*#__PURE__*/ react.createElement(CampaignListItem, {
            key: campaign.id
        }, /*#__PURE__*/ react.createElement(variants.H4Text, null, campaign.title.short), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            container: "p"
        }, campaign.description.short), /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
            campaign: campaign,
            linkContent: t("campaigns", "link.visit-campaign"),
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                    nextPage: campaign.web_uri.responsive
                });
            }
        }));
    })));
};
var arrayOf = (prop_types_default()).arrayOf, number = (prop_types_default()).number, shape = (prop_types_default()).shape, string = (prop_types_default()).string;
CampaignGroup.propTypes = {
    title: string,
    campaigns: arrayOf(shape({
        id: number.isRequired,
        slug: string,
        title: shape({
            short: string,
            long: string
        }),
        description: shape({
            short: string,
            long: string
        })
    }).isRequired),
    className: string
};
CampaignGroup.defaultProps = {
    title: undefined,
    className: undefined
};
/* harmony default export */ const campaign_group = (CampaignGroup);


/***/ }),

/***/ 22486:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ components_link)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(69346);
;// CONCATENATED MODULE: ./src/areas/campaign/components/link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TitleMediumTextLink = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "TitleMediumTextLink",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/campaign/components/link/index.js





var CampaignLink = function(props) {
    var renderMode = (0,react.useContext)(app_context/* AppContext */.Il).renderMode;
    var campaign = props.campaign, linkContent = props.linkContent, onClick = props.onClick;
    if (!linkContent) {
        return null;
    }
    if (renderMode === "native") {
        return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
            container: "a",
            containerProps: {
                href: campaign.web_uri.mobile,
                "data-test": props["data-test"],
                onClick: onClick
            }
        }, linkContent);
    }
    return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "".concat(campaign.web_uri.responsive).concat(props.queryString || ""),
            "data-test": props["data-test"],
            onClick: onClick
        }
    }, linkContent);
};
var shape = (prop_types_default()).shape, string = (prop_types_default()).string, node = (prop_types_default()).node, func = (prop_types_default()).func;
CampaignLink.propTypes = {
    linkContent: node,
    queryString: string,
    campaign: shape({
        title: shape({
            short: string
        }),
        description: shape({
            short: string
        }),
        web_uri: shape({
            desktop: string,
            mobile: string
        })
    }).isRequired,
    className: string,
    "data-test": string,
    onClick: func
};
CampaignLink.defaultProps = {
    linkContent: "",
    className: null,
    queryString: null,
    "data-test": undefined,
    onClick: undefined
};
/* harmony default export */ const components_link = (CampaignLink);


/***/ }),

/***/ 28607:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ article)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/components/featured-article/index.tsx + 5 modules
var featured_article = __webpack_require__(89647);
// EXTERNAL MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx + 1 modules
var breadcrumb = __webpack_require__(81490);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(98854);
// EXTERNAL MODULE: ./src/areas/article/query.graphql
var query_graphql = __webpack_require__(2222);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/article/queries/use-article-page-query.ts


function useArticlePageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "article",
        variables: variables
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/article/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 71.42857rem;\n  margin-right: auto;\n  margin-left: auto;\n  display: flex;\n  flex-flow: row wrap;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  margin-top: 0;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        " ",
        "\n    ",
        " 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ArticleWrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ArticleWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.margins.component.desktop.rem */.bK.margins.component.desktop.rem, base/* media.mediumDown */.BC.mediumDown(_templateObject(), base/* layout.margins.component.mobile.rem */.bK.margins.component.mobile.rem));
var Wrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject3(), base/* layout.margins.wrapper.desktop.rem */.bK.margins.wrapper.desktop.rem, base/* layout.margins.wrapper.desktop.rem */.bK.margins.wrapper.desktop.rem, base/* media.mediumDown */.BC.mediumDown(_templateObject2(), base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem, base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem));
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-2"
})(_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/article/article.tsx









var ArticlePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useArticlePageQuery(route === null || route === void 0 ? void 0 : route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data.article ? /*#__PURE__*/ react.createElement(ArticlePage, {
        article: data.article
    }) : null);
};
var ArticlePage = function(param) {
    var article = param.article;
    var renderBreadcrumb = function renderBreadcrumb() {
        var _related;
        var campaign = ((_related = article.related) !== null && _related !== void 0 ? _related : {}).campaign;
        if (campaign) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // TODO: fix this when merge
            return /*#__PURE__*/ react.createElement(breadcrumb/* default */.Z, {
                campaign: campaign,
                article: article
            });
        }
        return /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
            crumbs: [
                {
                    title: article.title
                }
            ]
        }));
    };
    return /*#__PURE__*/ react.createElement(ArticleWrapper, null, renderBreadcrumb(), /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(featured_article/* FeaturedArticle */.h, {
        article: article,
        embedded: false
    })));
};
/* harmony default export */ const article = (ArticlePageLoader);


/***/ }),

/***/ 81490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ breadcrumb)
});

// UNUSED EXPORTS: CampaignBreadcrumb

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/campaign/components/breadcrumb/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
;// CONCATENATED MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var CampaignBreadcrumb = function(props) {
    var campaign = props.campaign;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var base = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.campaign.base;
    });
    var getBreadcrumbPath = function() {
        var path = _toConsumableArray(base ? [
            {
                id: "campaigns",
                name: t("campaigns", "themes.breadcrumb"),
                pathName: base
            }
        ] : []);
        if (campaign) {
            if (base) {
                path.push({
                    id: "".concat(campaign.id),
                    name: campaign.name || "",
                    pathName: "".concat(base, "/").concat(campaign.slug)
                });
            }
            if (props.article) {
                path.push({
                    id: "".concat(props.article.id),
                    name: props.article.title,
                    pathName: props.article.pathName
                });
            }
        }
        return path;
    };
    var paths = getBreadcrumbPath();
    return /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: paths.map(function(param, index) {
            var name = param.name, pathName = param.pathName;
            return {
                href: paths.length - 1 !== index ? pathName : undefined,
                title: name
            };
        })
    }));
};
/* harmony default export */ const breadcrumb = (CampaignBreadcrumb);


/***/ }),

/***/ 32838:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bx": () => (/* binding */ trackChangelogArticleViewed),
/* harmony export */   "bG": () => (/* binding */ trackChangelogOpened),
/* harmony export */   "hJ": () => (/* binding */ trackChangelogArticlesListed)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80695);

var trackChangelogOpened = function() {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("changelogOpened");
};
var trackChangelogArticleViewed = function(param) {
    var id = param.id;
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("changelogArticleViewed", {
        id: id
    });
};
var trackChangelogArticlesListed = function(param) {
    var page = param.page;
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("changelogArticlesListed", {
        page: page
    });
};


/***/ }),

/***/ 7685:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ editorial_content_listing)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(83018);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/number-pagination/index.tsx + 3 modules
var number_pagination = __webpack_require__(56710);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(76891);
// EXTERNAL MODULE: ./src/areas/landing-page/components/featured-article/index.tsx + 1 modules
var featured_article = __webpack_require__(10662);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(98854);
// EXTERNAL MODULE: ./src/areas/editorial-content-listing/query.graphql
var query_graphql = __webpack_require__(50973);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/editorial-content-listing/queries/use-editorial-content-listing-page-query.ts


function useEditorialContentListingPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "editorialContentListing",
        variables: variables
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/editorial-content-listing/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ArticleListWrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ArticleListWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem);
var PaginationWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PaginationWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/editorial-content-listing/editorial-content-listing.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var scrollToTop = function() {
    if (true) {
        window.scrollTo({
            top: 0
        });
    }
};
var EditorialContentListingPageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useEditorialContentListingPageQuery(route === null || route === void 0 ? void 0 : route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data.prismicArticles ? /*#__PURE__*/ react.createElement(EditorialContentListingPage, {
        prismicArticles: data.prismicArticles
    }) : null);
};
var EditorialContentListingPage = function(param) {
    var prismicArticles = param.prismicArticles;
    var ref;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var search = (0,react_router/* useLocation */.TH)().search;
    var pageInfo = prismicArticles.pageInfo;
    var totalCount = prismicArticles.totalCount;
    var currentPage = pageInfo && typeof pageInfo.offset === "number" && typeof pageInfo.limit === "number" ? Math.floor(pageInfo.offset / pageInfo.limit) + 1 : 1;
    var generatePaginationUrl = (0,react.useCallback)(function(pageNumber) {
        return "?".concat(dist_default().stringify(_objectSpreadProps(_objectSpread({}, dist_default().parse(search.substring(1))), {
            offset: (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit) && pageNumber > 1 ? (pageNumber - 1) * pageInfo.limit : undefined
        })));
    }, [
        search,
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.limit
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("common", "article.articles")
            }
        ]
    })), /*#__PURE__*/ react.createElement(ArticleListWrapper, null, /*#__PURE__*/ react.createElement(page/* PageHeader */.mr, {
        title: t("common", "article.articles")
    }), (ref = prismicArticles.nodes) === null || ref === void 0 ? void 0 : ref.map(function(article) {
        var ref;
        return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
            key: article.id
        }, /*#__PURE__*/ react.createElement(featured_article/* default */.Z, {
            key: article.id,
            pathName: article.pathName,
            imageUrl: (ref = article.data.featuredImage) === null || ref === void 0 ? void 0 : ref.url,
            title: (0,rich_text/* plainText */.K)(article.data.title),
            preamble: (0,rich_text/* plainText */.K)(article.data.metaDescription),
            linkText: t("landing", "featured-article.read-more")
        }));
    })), /*#__PURE__*/ react.createElement(PaginationWrapper, null, /*#__PURE__*/ react.createElement(number_pagination/* NumberPagination */.O, {
        currentPage: currentPage,
        totalPages: pageInfo.limit && totalCount ? Math.ceil(totalCount / pageInfo.limit) : 1,
        linkToPage: generatePaginationUrl,
        onClick: scrollToTop
    })));
};
/* harmony default export */ const editorial_content_listing = (EditorialContentListingPageLoader);


/***/ }),

/***/ 53178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ faq)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/ui/accordion/index.tsx + 5 modules
var accordion = __webpack_require__(84270);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(76891);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/faq/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & > :last-child {\n    margin-bottom: 0 !important;\n  }\n\n  & a {\n    color: ",
        ";\n  }\n\n  & a:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var FaqContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FaqContainer",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var span = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "span",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/faq/index.tsx




var FAQ = function(param) {
    var faqTitle = param.faqTitle, items = param.items;
    return /*#__PURE__*/ react.createElement(FaqContainer, null, faqTitle && /*#__PURE__*/ react.createElement(rich_text/* default */.Z, {
        data: faqTitle
    }), Array.isArray(items) ? items.map(function(item) {
        var questionAsPlainText = (0,rich_text/* plainText */.K)(item.question);
        return /*#__PURE__*/ react.createElement(accordion/* Accordion */.UQ, {
            key: questionAsPlainText,
            id: questionAsPlainText
        }, /*#__PURE__*/ react.createElement(accordion/* AccordionHeader */._m, null, /*#__PURE__*/ react.createElement(span, {
            data: item.question
        })), /*#__PURE__*/ react.createElement(accordion/* AccordionContent */.vF, null, /*#__PURE__*/ react.createElement(span, {
            data: item.answer
        })));
    }) : null);
};
/* harmony default export */ const faq = (FAQ);


/***/ }),

/***/ 8586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ editorial_content)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/areas/changelog/tracking/index.ts
var tracking = __webpack_require__(32838);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/areas/editorial-content/tracking/index.ts

var trackContentViewed = function(id) {
    (0,data_layer/* pushEvent */.A)("contentViewed", {
        id: id
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33300);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(69346);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/article-carousel/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100% !important;\n\n  > span {\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 235px;\n  height: 390px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 120px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        " !important;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 10;\n  max-height: 102px;\n  text-overflow: ellipsis;\n  /* stylelint-disable value-no-vendor-prefix  */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 5;\n  overflow: hidden;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var ArticleCarouselContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ArticleCarouselContainer",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ReadMoreLink = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "ReadMoreLink",
    componentId: "sc-0-1"
})(_templateObject1());
var ArticlePreviewCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "ArticlePreviewCard",
    componentId: "sc-0-2"
})(_templateObject2());
var ArticlePreviewCardMedia = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "ArticlePreviewCardMedia",
    componentId: "sc-0-3"
})(_templateObject3());
var ArticlePreviewCardContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "ArticlePreviewCardContent",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var EllipsisSmallText = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "EllipsisSmallText",
    componentId: "sc-0-5"
})(_templateObject5());

// EXTERNAL MODULE: ./src/areas/expert/styles.ts
var styles = __webpack_require__(23599);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/variants/medium-card-horizontal-scroll.tsx
var medium_card_horizontal_scroll = __webpack_require__(19184);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(76891);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/article-carousel/index.tsx







var ArticleCarousel = function(param) {
    var articles = param.articles;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(ArticleCarouselContainer, null, /*#__PURE__*/ react.createElement(medium_card_horizontal_scroll/* MediumCardHorizontalScroll */._, null, articles.map(function(article) {
        return /*#__PURE__*/ react.createElement(ArticlePreviewCard, {
            key: article.id
        }, /*#__PURE__*/ react.createElement(ArticlePreviewCardMedia, null, /*#__PURE__*/ react.createElement("img", {
            src: article.image.url,
            alt: article.image.alt || ""
        })), /*#__PURE__*/ react.createElement(ArticlePreviewCardContent, null, /*#__PURE__*/ react.createElement(styles/* CardTitle */.ll, null, (0,rich_text/* plainText */.K)(article.title)), article.preamble && /*#__PURE__*/ react.createElement(EllipsisSmallText, null, (0,rich_text/* plainText */.K)(article.preamble)), /*#__PURE__*/ react.createElement(ReadMoreLink, {
            container: clickable/* Clickable */.P,
            containerProps: {
                isExternal: false,
                to: "".concat(Array.isArray(article.slugs) && article.slugs.length > 0 ? article.slugs[article.slugs.length - 1] : "", "--ec").concat(article.id)
            }
        }, t("landing", "featured-article.read-more"))));
    })));
};
/* harmony default export */ const article_carousel = (ArticleCarousel);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/call-to-action/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  margin: 0 auto;\n  min-width: 50%;\n  text-align: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CallToActionContainer = styled_components_browser_esm["default"].section.withConfig({
    displayName: "CallToActionContainer",
    componentId: "sc-0-0"
})(styles_templateObject());
var CallToActionButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).attrs({
    fullWidth: false,
    size: variants.ButtonSize.LARGE
}).withConfig({
    displayName: "CallToActionButton",
    componentId: "sc-0-1"
})(styles_templateObject1());

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/call-to-action/index.tsx





var isAbsoluteUrl = function(url) {
    return url.startsWith("http");
};
var isExternalLink = function(url, siteUrl) {
    return isAbsoluteUrl(url) && getLinkHostname(url) !== getLinkHostname(siteUrl || "");
};
var getLinkHostname = function(url) {
    return isAbsoluteUrl(url) ? new URL(url).host : undefined;
};
var getLinkPath = function(url) {
    return isAbsoluteUrl(url) ? new URL(url).pathname : url;
};
var CallToAction = function(param) {
    var buttonTitle = param.buttonTitle, buttonUrl = param.buttonUrl;
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    var isExternal = isExternalLink(buttonUrl, market.sites.production);
    var toLink = isExternal ? buttonUrl : getLinkPath(buttonUrl);
    return /*#__PURE__*/ react.createElement(CallToActionContainer, null, /*#__PURE__*/ react.createElement(CallToActionButton, {
        container: clickable/* Clickable */.P,
        containerProps: {
            isExternal: isExternal,
            to: toLink,
            containerProps: {
                target: isExternal ? "_blank" : undefined,
                onClick: function() {
                    return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.CALL_TO_ACTION */.U.CALL_TO_ACTION,
                        nextPage: toLink
                    });
                }
            }
        },
        ariaLabel: buttonTitle
    }, buttonTitle));
};
/* harmony default export */ const call_to_action = (CallToAction);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/visual-navigation/index.js
var visual_navigation = __webpack_require__(68585);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/categories/index.tsx






var Categories = function(param) {
    var optionalTitle = param.optionalTitle, categories = param.categories;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, linkTo = ref.linkTo;
    var ref1;
    var formattedLinks = (0,react.useMemo)(function() {
        return (ref1 = categories === null || categories === void 0 ? void 0 : categories.filter(function(category) {
            return category !== null;
        }).map(function(category) {
            var link = {
                id: (category === null || category === void 0 ? void 0 : category.id) || "",
                value: (category === null || category === void 0 ? void 0 : category.name) || "",
                selected: false,
                path: (category === null || category === void 0 ? void 0 : category.type) === "classic" && market.useClassicUrls ? linkTo("category", category) : category === null || category === void 0 ? void 0 : category.path,
                imageUrl: (category === null || category === void 0 ? void 0 : category.image) || (category === null || category === void 0 ? void 0 : category.fallbackImage),
                indexable: true
            };
            return link;
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        categories,
        linkTo,
        market.useClassicUrls
    ]);
    if (!categories) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, optionalTitle && /*#__PURE__*/ react.createElement(rich_text/* default */.Z, {
        data: optionalTitle
    }), /*#__PURE__*/ react.createElement(visual_navigation/* VisualNavigation */.rH, {
        linksPerRow: 4,
        compact: true
    }, formattedLinks.map(function(link, index) {
        return /*#__PURE__*/ react.createElement(visual_navigation/* VisualNavigationLink */.Kr, {
            key: link.id,
            label: link.value,
            imageSrc: link.imageUrl || "",
            imageAlt: link.value,
            containerProps: {
                title: link.value
            },
            linkContainer: react_router_dom/* Link */.rU,
            linkContainerProps: {
                to: link.path,
                onClick: function() {
                    if (link.path) {
                        (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                            scope: tracking_tracking/* InternalNavigationScope.CATEGORY_CARD */.U.CATEGORY_CARD,
                            nextPage: link.path,
                            index: index
                        });
                    }
                }
            }
        });
    })));
};
/* harmony default export */ const categories = (Categories); /*

      
*/ 

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(91661);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(55913);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/styles.ts
var horizontal_scroll_styles = __webpack_require__(65773);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/columns/styles.ts
function columns_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function columns_styles_templateObject() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    columns_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function columns_styles_templateObject1() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    columns_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n    width: ",
        ";\n    min-width: ",
        ";\n    margin: ",
        ";\n    padding: ",
        ";\n    background: ",
        ";\n    background-size: cover;\n    background-position-x: 50%;\n    border-radius: ",
        ";\n    display: flex;\n    flex-direction: column;\n    justify-content: ",
        ";\n    ",
        ";\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n      height: fit-content;\n      "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n    ",
        "\n    min-width: 234px;\n    margin: auto;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  height: 220px;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  max-height: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  text-align: center;\n  max-height: 50px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  color: ",
        " !important;\n  margin: 0 auto;\n  width: 100%;\n  text-align: center;\n  padding: ",
        " !important;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = columns_styles_taggedTemplateLiteral([
        "\n  li > * {\n    width: 234px;\n    height: 100%;\n  }\n  ",
        " {\n    li {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}







var getRightFontColor = function(color) {
    return color.endsWith("Base900") ? base/* colors.lightTheme.base900 */.O9.lightTheme.base900 : base/* colors.lightTheme.base0 */.O9.lightTheme.base0;
};
var MainTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MainTitle",
    componentId: "sc-0-0"
})(columns_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ColumnContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ColumnContainer",
    componentId: "sc-0-1"
})(columns_styles_templateObject1());
var columnCSS = function(props) {
    var bg = props.bgImageUrl && !props.pictureCarousel ? "url('".concat(props.bgImageUrl, "')") : props.bgColor;
    return (0,styled_components_browser_esm.css)(styles_templateObject2(), props.imageHeight ? "".concat(props.imageHeight, "px") : "", props.isImageOfProduct || props.numberOfColumns > 4 ? "234px" : "".concat(100 / props.numberOfColumns, "%"), props.isImageOfProduct || props.numberOfColumns > 4 ? "234px" : "", base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.pictureCarousel ? "" : base/* layout.measurements.spacing100 */.bK.measurements.spacing100, bg, base/* layout.borderRadius */.bK.borderRadius, props.isImageOfProduct ? "flex-end" : "space-between", props.isImageOfProduct ? "text-align: center;" : null);
};
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject4(), props.imageHeight ? "".concat(props.imageHeight, "px") : "", base/* media.mediumDown */.BC.mediumDown(styles_templateObject3()));
});
var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-3"
})(columnCSS);
var ColumnAsLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ColumnAsLink",
    componentId: "sc-0-4"
})(columnCSS);
// Agreed upon size for the product in the background image.
var CenteredTransparentBoxForProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CenteredTransparentBoxForProductImage",
    componentId: "sc-0-5"
})(styles_templateObject5());
var CenteredSmallTitle = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "CenteredSmallTitle",
    componentId: "sc-0-6"
})(_templateObject6());
var CenteredText = (0,styled_components_browser_esm["default"])(text_variants.BodyMediumText).withConfig({
    displayName: "CenteredText",
    componentId: "sc-0-7"
})(_templateObject7());
var ColumnTitleAndText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ColumnTitleAndText",
    componentId: "sc-0-8"
})(_templateObject8(), function(p) {
    return getRightFontColor(p.color);
});
var ColumnButton = (0,styled_components_browser_esm["default"])(ui_button.Button).attrs({
    fullWidth: true,
    size: variants.ButtonSize.NORMAL
}).withConfig({
    displayName: "ColumnButton",
    componentId: "sc-0-9"
})(_templateObject9(), function(p) {
    return getRightFontColor(p.color);
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ColumnHorizontalScroll = (0,styled_components_browser_esm["default"])(horizontal_scroll/* default */.C).withConfig({
    displayName: "ColumnHorizontalScroll",
    componentId: "sc-0-10"
})(_templateObject10(), horizontal_scroll_styles/* List */.aV);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/columns/index.tsx







var Columns = function(param) {
    var columns = param.columns, columnsTitle = param.columnsTitle, columnsDescription = param.columnsDescription, pictureCarousel = param.pictureCarousel;
    var ref = (0,react.useContext)(viewport/* ViewportContext */.R), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var linkIsExternal = function(linkOrPath) {
        return linkOrPath.startsWith("http");
    };
    /* Use horizontal scoll if:
   * 1. More than 4 columns
   * OR
   * 2. If its a mobile/tablet and there is more than one column
   */ var useHorizontalScroll = columns.length > 4 || isMobile && columns.length > 1 || isTablet && columns.length > 2;
    var getTitle = function(imageIsOfProduct, title, textColor) {
        if (imageIsOfProduct) return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(CenteredTransparentBoxForProductImage, null), /*#__PURE__*/ react.createElement(CenteredSmallTitle, {
            color: textColor.startsWith(text_variants.FontColor.LIGHT) ? text_variants.FontColor.LIGHT : text_variants.FontColor.DARK
        }, (0,rich_text/* plainText */.K)(title)));
        return /*#__PURE__*/ react.createElement(rich_text/* default */.Z, {
            data: title
        });
    };
    var getText = function(imageIsOfProduct, text, textColor) {
        if (imageIsOfProduct) return /*#__PURE__*/ react.createElement(CenteredText, {
            color: textColor.startsWith(text_variants.FontColor.LIGHT) ? text_variants.FontColor.LIGHT : text_variants.FontColor.DARK,
            behavior: text_variants.Behavior.TwolineEllipsis,
            weight: text_variants.FontWeight.HEAVIEST
        }, (0,rich_text/* plainText */.K)(text));
        return /*#__PURE__*/ react.createElement(rich_text/* default */.Z, {
            data: text
        });
    };
    var columnsAndContent = (0,react.useMemo)(function() {
        var columnContent = function(item) {
            if (pictureCarousel) {
                var ref;
                var ref1, _heightOfImage;
                return /*#__PURE__*/ react.createElement(Image, {
                    src: (ref1 = (ref = item.image) === null || ref === void 0 ? void 0 : ref.url) !== null && ref1 !== void 0 ? ref1 : "",
                    imageHeight: (_heightOfImage = item.heightOfImage) !== null && _heightOfImage !== void 0 ? _heightOfImage : undefined,
                    numberOfColumns: columns.length
                });
            }
            return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ColumnTitleAndText, {
                color: item.textColor
            }, item.title ? getTitle(item.imageIsOfProduct, item.title, item.textColor) : null, item.text ? getText(item.imageIsOfProduct, item.text, item.textColor) : null), item.buttonText && item.buttonLinkOrPath ? /*#__PURE__*/ react.createElement(ColumnButton, {
                type: item.buttonType === ui_button.ButtonType.TONAL ? ui_button.ButtonType.TONAL : ui_button.ButtonType.PRIMARY,
                color: item.buttonType === ui_button.ButtonType.TONAL ? item.textColor : "",
                container: clickable/* Clickable */.P,
                containerProps: {
                    isExternal: linkIsExternal(item.buttonLinkOrPath),
                    to: item.buttonLinkOrPath,
                    target: linkIsExternal(item.buttonLinkOrPath) ? "_blank" : undefined
                },
                ariaLabel: (0,rich_text/* plainText */.K)(item.buttonText)
            }, (0,rich_text/* plainText */.K)(item.buttonText)) : null);
        };
        return Array.isArray(columns) ? columns.map(function(item) {
            var ref;
            var key = "".concat((0,rich_text/* plainText */.K)(item.title || []), "-").concat((ref = item.image) === null || ref === void 0 ? void 0 : ref.url, "-").concat(item.backgroundcolor);
            var _heightOfImage;
            // Image background with link
            if (item.image && item.imageLinkOrPath) return /*#__PURE__*/ react.createElement(ColumnAsLink, {
                href: item.imageLinkOrPath,
                target: linkIsExternal(item.imageLinkOrPath || "") ? "_blank" : undefined,
                key: key,
                bgColor: item.backgroundcolor || null,
                bgImageUrl: item.image ? item.image.url : null,
                imageHeight: (_heightOfImage = item.heightOfImage) !== null && _heightOfImage !== void 0 ? _heightOfImage : undefined,
                isImageOfProduct: item.imageIsOfProduct,
                numberOfColumns: columns.length,
                pictureCarousel: pictureCarousel !== null && pictureCarousel !== void 0 ? pictureCarousel : false
            }, columnContent(item));
            var _heightOfImage1;
            // No image backgournd link (could be image background only with no link)
            return /*#__PURE__*/ react.createElement(Column, {
                key: key,
                bgColor: item.backgroundcolor || null,
                bgImageUrl: item.image ? item.image.url : null,
                imageHeight: (_heightOfImage1 = item.heightOfImage) !== null && _heightOfImage1 !== void 0 ? _heightOfImage1 : undefined,
                isImageOfProduct: item.imageIsOfProduct,
                numberOfColumns: columns.length,
                pictureCarousel: pictureCarousel !== null && pictureCarousel !== void 0 ? pictureCarousel : false
            }, columnContent(item));
        }) : null;
    }, [
        columns
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MainTitle, null, columnsTitle ? /*#__PURE__*/ react.createElement(rich_text/* default */.Z, {
        data: columnsTitle
    }) : null, columnsDescription ? /*#__PURE__*/ react.createElement(rich_text/* default */.Z, {
        data: columnsDescription
    }) : null), useHorizontalScroll ? /*#__PURE__*/ react.createElement(ColumnHorizontalScroll, {
        showArrows: "always"
    }, columnsAndContent) : /*#__PURE__*/ react.createElement(ColumnContainer, null, columnsAndContent));
};
/* harmony default export */ const columns = (Columns);

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/faq/index.tsx + 1 modules
var faq = __webpack_require__(53178);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/article/styles.ts
function article_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function article_styles_templateObject() {
    var data = article_styles_taggedTemplateLiteral([
        ""
    ]);
    article_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function article_styles_templateObject1() {
    var data = article_styles_taggedTemplateLiteral([
        "\n  @media screen and (min-width: 2056px) {\n    margin-left: 0;\n  }\n  margin-bottom: 0;\n"
    ]);
    article_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ArticleComponent = styled_components_browser_esm["default"].article.withConfig({
    displayName: "ArticleComponent",
    componentId: "sc-0-0"
})(article_styles_templateObject());
var PageContent = (0,styled_components_browser_esm["default"])(page/* PageContent */.JH).withConfig({
    displayName: "PageContent",
    componentId: "sc-0-1"
})(article_styles_templateObject1());

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/hero/styles.ts
var hero_styles = __webpack_require__(29035);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/hero/index.tsx



var Hero = function(param) {
    var textColor = param.textColor, heroImage = param.heroImage, title = param.title, secondaryTitle = param.secondaryTitle, textAlign = param.textAlign, heroBackgroundColor = param.heroBackgroundColor, titleBoxWidth = param.titleBoxWidth;
    return /*#__PURE__*/ react.createElement(hero_styles/* Hero */.VM, {
        textColor: textColor,
        heroImage: heroImage,
        heroBackgroundColor: heroBackgroundColor
    }, /*#__PURE__*/ react.createElement(PageContent, {
        alignLeft: true
    }, /*#__PURE__*/ react.createElement(hero_styles/* TextContent */.D7, {
        titleBoxWidth: titleBoxWidth
    }, /*#__PURE__*/ react.createElement(hero_styles/* Title */.Dx, {
        data: title,
        textAlign: textAlign
    }), /*#__PURE__*/ react.createElement(hero_styles/* SubTitle */.DK, {
        data: secondaryTitle,
        textAlign: textAlign
    }))));
};
/* harmony default export */ const hero = (Hero);

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/image/styles.ts
function image_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function image_styles_templateObject() {
    var data = image_styles_taggedTemplateLiteral([
        "\n  figure {\n    img {\n      display: block;\n      margin: 0 auto;\n      max-width: 100%;\n      border-radius: 8px;\n    }\n    figcaption {\n      text-align: left;\n      margin-top: ",
        ";\n    }\n  }\n"
    ]);
    image_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styles_Image = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(image_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/image/index.tsx




var image_Image = function(param) {
    var className = param.className, image = param.image, imageLinkOrPath = param.imageLinkOrPath;
    var isExternal = imageLinkOrPath === null || imageLinkOrPath === void 0 ? void 0 : imageLinkOrPath.startsWith("http");
    return image ? /*#__PURE__*/ react.createElement(styles_Image, {
        className: className
    }, /*#__PURE__*/ react.createElement("figure", null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: imageLinkOrPath !== null && imageLinkOrPath !== void 0 ? imageLinkOrPath : "",
        target: isExternal ? "_blank" : "",
        isExternal: isExternal,
        disabled: !imageLinkOrPath
    }, /*#__PURE__*/ react.createElement("img", {
        src: image.url,
        alt: image.alt || ""
    }))), image.alt ? /*#__PURE__*/ react.createElement("figcaption", null, image.alt) : null)) : null;
};
/* harmony default export */ const slices_image = (image_Image);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/shared/grid-width.ts
// Returns width of elements in a 2x1 grid based on the Prismic gridLayout (ie. 1:2)
var gridWidth = function(grid) {
    var base = 33;
    if (grid === "1:1") return [
        "50%",
        "50%"
    ];
    return grid.split(":").map(function(x) {
        return "".concat(parseInt(x, 10) * base, "%");
    });
};
/* harmony default export */ const grid_width = (gridWidth);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/image-text/styles.ts
function image_text_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function image_text_styles_templateObject() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n      > * {\n        flex-grow: 1;\n        width: 50%;\n      }\n    "
    ]);
    image_text_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function image_text_styles_templateObject1() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n      flex-direction: ",
        ";\n    "
    ]);
    image_text_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function image_text_styles_templateObject2() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    image_text_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function image_text_styles_templateObject3() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      padding-left: 0;\n      padding-right: 0;\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n      order: ",
        "\n    "
    ]);
    image_text_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function image_text_styles_templateObject4() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    ",
        ";\n  "
    ]);
    image_text_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function image_text_styles_templateObject5() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n      display: flex;\n      width: 100%;\n      padding-left: 0;\n      padding-right: 0;\n      padding-top: 0;\n      padding-bottom: ",
        ";\n      order: ",
        "\n    "
    ]);
    image_text_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = image_text_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    ",
        ";\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var ImageText = styled_components_browser_esm["default"].section.withConfig({
    displayName: "ImageText",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(image_text_styles_templateObject2(), props.reverse ? "row-reverse" : "row", base/* media.mediumUp */.BC.mediumUp(image_text_styles_templateObject()), base/* media.smallOnly */.BC.smallOnly(image_text_styles_templateObject1(), props.reverse ? "column-reverse" : "column"));
});
var Text = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(image_text_styles_templateObject4(), props.width, !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, base/* media.smallOnly */.BC.smallOnly(image_text_styles_templateObject3(), !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, props.reverse ? 0 : 1));
});
var image_text_styles_Image = (0,styled_components_browser_esm["default"])(slices_image).withConfig({
    displayName: "Image",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject6(), props.width, props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, base/* media.smallOnly */.BC.smallOnly(image_text_styles_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, props.reverse ? 1 : 0));
});

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/image-text/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var image_text_ImageText = function(param) {
    var text = param.text, image = param.image, _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse, gridLayout = param.gridLayout, imageLinkOrPath = param.imageLinkOrPath;
    var width = grid_width(gridLayout);
    var properties = {
        image: image,
        imageLinkOrPath: imageLinkOrPath
    };
    return /*#__PURE__*/ react.createElement(ImageText, {
        reverse: reverse
    }, /*#__PURE__*/ react.createElement(image_text_styles_Image, _extends({}, properties, {
        width: width[reverse ? 1 : 0],
        reverse: reverse
    })), /*#__PURE__*/ react.createElement(Text, {
        data: text,
        width: width[reverse ? 0 : 1],
        reverse: reverse
    }));
};
/* harmony default export */ const image_text = (image_text_ImageText);

// EXTERNAL MODULE: ./src/components/newsletter-signup/legal-link.tsx
var legal_link = __webpack_require__(15866);
// EXTERNAL MODULE: ./src/components/newsletter-signup/styles.ts
var newsletter_signup_styles = __webpack_require__(68360);
// EXTERNAL MODULE: ./src/components/newsletter-signup/useNewsletterSignup.ts + 1 modules
var useNewsletterSignup = __webpack_require__(25772);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/newsletter/styles.ts
function newsletter_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function newsletter_styles_templateObject() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  height: 100%;\n  width: 100%;\n"
    ]);
    newsletter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newsletter_styles_templateObject1() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n      width: 100%\n    "
    ]);
    newsletter_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function newsletter_styles_templateObject2() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n\n  > input {\n    height: 40px;\n  }\n\n  ",
        "\n"
    ]);
    newsletter_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function newsletter_styles_templateObject3() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    newsletter_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function newsletter_styles_templateObject4() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n    align-items: center;\n    gap: ",
        ";\n    width: 100%;\n    justify-content: center;\n  "
    ]);
    newsletter_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function newsletter_styles_templateObject5() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: 0;\n\n  ",
        " {\n    a {\n      color: ",
        ";\n\n      :hover {\n        color: ",
        ";\n      }\n    }\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    flex-wrap: nowrap;\n    flex-direction: row;\n  }\n\n  ",
        "\n"
    ]);
    newsletter_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function newsletter_styles_templateObject6() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n    flex-grow: 1;\n    max-width: 260px;\n    margin-bottom: ",
        ";\n  "
    ]);
    newsletter_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " ",
        "\n    auto 0;\n\n  > * {\n    margin: 0;\n  }\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n      width: 100%;\n      margin-left: 0;\n      margin-top: ",
        ";\n    "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n      flex-direction: column;\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  flex-grow: 1;\n\n  form {\n    margin: 0;\n  }\n\n  ",
        " {\n    width: unset;\n\n    ",
        "\n  }\n\n  > form > ",
        " {\n    ",
        "\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = newsletter_styles_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var Button = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(newsletter_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var InlineInput = (0,styled_components_browser_esm["default"])(inputs/* TextInput */.oi).withConfig({
    displayName: "InlineInput",
    componentId: "sc-0-1"
})(newsletter_styles_templateObject2(), base/* media.smallDown */.BC.smallDown(newsletter_styles_templateObject1()));
var _width;
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-2"
})(newsletter_styles_templateObject5(), function(props) {
    return (0,styled_components_browser_esm.css)(newsletter_styles_templateObject3(), (_width = props.width) !== null && _width !== void 0 ? _width : "70%");
}, function(p) {
    return p.theme.colors.base100;
}, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.borderRadius */.bK.borderRadius, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, newsletter_signup_styles/* Legal */.Q2, function(p) {
    return p.theme.colors.base600;
}, function(p) {
    return p.theme.colors.base600;
}, newsletter_signup_styles/* Feedback */.x2, function(p) {
    return p.theme.colors.negative700;
}, newsletter_signup_styles/* Flex */.kC, base/* media.smallDown */.BC.smallDown(newsletter_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var NewsletterHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NewsletterHeader",
    componentId: "sc-0-3"
})(styles_templateObject7(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallDown */.BC.smallDown(newsletter_styles_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var NewsletterInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NewsletterInput",
    componentId: "sc-0-4"
})(styles_templateObject10(), Button, base/* media.smallDown */.BC.smallDown(styles_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100), newsletter_signup_styles/* Flex */.kC, base/* media.smallDown */.BC.smallDown(styles_templateObject9()));
var InlineInputContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InlineInputContainer",
    componentId: "sc-0-5"
})(_templateObject11());

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/newsletter/index.tsx







var Newsletter = function(param) {
    var header = param.header, width = param.width;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,useNewsletterSignup/* useNewsletterSignup */.H)(), _state = ref.state, signupFeedbackTranslationKey = _state.signupFeedbackTranslationKey, isSubscribed = _state.isSubscribed, loading = _state.loading, handleSubmit = ref.handleSubmit, handleChange = ref.handleChange, privacyPolicyUri = ref.privacyPolicyUri;
    return /*#__PURE__*/ react.createElement(Container, {
        width: width
    }, /*#__PURE__*/ react.createElement(NewsletterInput, null, !isSubscribed ? /*#__PURE__*/ react.createElement(newsletter_signup_styles/* Form */.l0, {
        method: "post",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ react.createElement(newsletter_signup_styles/* Flex */.kC, null, header ? /*#__PURE__*/ react.createElement(NewsletterHeader, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, header)) : null, /*#__PURE__*/ react.createElement(InlineInputContainer, null, /*#__PURE__*/ react.createElement(InlineInput, {
        type: "email",
        name: "email",
        helper: t("campaigns", signupFeedbackTranslationKey),
        onChange: handleChange,
        variant: "rounded",
        placeholder: t("campaigns", "newsletter.email-placeholder"),
        ariaLabel: t("campaigns", "newsletter.email-input-aria-label"),
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(legal_link/* default */.Z, {
        privacyPolicyUri: privacyPolicyUri
    })), /*#__PURE__*/ react.createElement(Button, {
        loading: loading,
        htmlType: "submit"
    }, t("campaigns", "newsletter.sign-up-button")))) : /*#__PURE__*/ react.createElement(newsletter_signup_styles/* Text */.xv, null, /*#__PURE__*/ react.createElement(newsletter_signup_styles/* SubscribedCheckIcon */._t, null), /*#__PURE__*/ react.createElement(newsletter_signup_styles/* SubscribeTitle */.cB, null, t("campaigns", "newsletter.sign-up-success")))));
};
/* harmony default export */ const newsletter = (Newsletter);

// EXTERNAL MODULE: ./src/components/cards-carousel/index.tsx + 9 modules
var cards_carousel = __webpack_require__(7183);
// EXTERNAL MODULE: ./src/components/cards-carousel/carousel-context.tsx
var carousel_context = __webpack_require__(22556);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/popular-products/index.tsx





var PopularProducts = function(param) {
    var popularFacet = param.popularFacet;
    var ref;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!(popularFacet === null || popularFacet === void 0 ? void 0 : (ref = popularFacet.products) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    var title = popularFacet.title, url = popularFacet.url, linkText = popularFacet.linkText, products = popularFacet.products;
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: products,
        linkPath: url,
        linkTitle: linkText !== null && linkText !== void 0 ? linkText : t("common", "button.show-more"),
        onHeaderLinkClick: function() {
            return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: tracking_tracking/* InternalNavigationScope.POPULAR_PRODUCTS_HEADER */.U.POPULAR_PRODUCTS_HEADER,
                nextPage: url
            });
        },
        onCardClick: function(data) {
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: tracking_tracking/* InternalNavigationScope.POPULAR_PRODUCTS_PRODUCT_CARD */.U.POPULAR_PRODUCTS_PRODUCT_CARD,
                nextPage: data.link,
                index: data.index
            });
        },
        title: title !== null && title !== void 0 ? title : ""
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};
/* harmony default export */ const popular_products = (PopularProducts);

// EXTERNAL MODULE: ./src/areas/expert/components/expert-offer-list-card/index.tsx + 2 modules
var expert_offer_list_card = __webpack_require__(66467);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/product/styles.ts
function product_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_styles_templateObject() {
    var data = product_styles_taggedTemplateLiteral([
        ""
    ]);
    product_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_styles_templateObject1() {
    var data = product_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    product_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_styles_templateObject2() {
    var data = product_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 0;\n  font-size: 1rem;\n"
    ]);
    product_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var styles_Container = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Container",
    componentId: "sc-0-0"
})(product_styles_templateObject());
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(product_styles_templateObject1());
var Title = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(product_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/product/index.tsx



var isPrismicRichText = function(obj) {
    return obj && typeof obj.text === "string" && typeof obj.type === "string" && Array.isArray(obj.spans);
};
var Product = function(param) {
    var title = param.title, product = param.product;
    var ref, ref1;
    if (!product) {
        return null;
    }
    var titleData = title && isPrismicRichText(title[0]) && title[0].text.length > 0 ? title : [
        {
            spans: [],
            text: product.name,
            type: title && isPrismicRichText(title[0]) ? title[0].type : "heading2"
        }
    ];
    return /*#__PURE__*/ react.createElement(styles_Container, null, /*#__PURE__*/ react.createElement(Title, {
        data: titleData
    }), /*#__PURE__*/ react.createElement(expert_offer_list_card/* ExpertOfferListCard */.A, {
        name: product.name,
        id: product.id,
        imageSrc: (ref = product.media) === null || ref === void 0 ? void 0 : ref.first,
        link: product.pathName,
        rating: product.userReviewSummary.rating,
        rank: (ref1 = product.popularity) === null || ref1 === void 0 ? void 0 : ref1.inCategory,
        reviewsCount: product.userReviewSummary.count,
        prices: product.prices,
        campaignProducts: {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: function() {}
    }));
};
/* harmony default export */ const product = (Product);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/product-list/index.tsx






var ProductList = function(param) {
    var title = param.title, products = param.products, listType = param.listType;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, linkTo = ref.linkTo;
    var showCompareLink = listType === "Compare";
    var compareTitle = showCompareLink ? t("product", "product-compare.compare") : undefined;
    var compareUrl = showCompareLink ? linkTo("productCompare", {
        products: products
    }) : undefined;
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: Array.isArray(products) ? products.filter(function(obj) {
            return Boolean(obj);
        }) : [],
        linkTitle: compareTitle,
        linkPath: compareUrl,
        onCardClick: function(data) {
            return (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: tracking_tracking/* InternalNavigationScope.ARTICLE_PRODUCT_CARD */.U.ARTICLE_PRODUCT_CARD,
                nextPage: data.link,
                index: data.index
            });
        },
        showCreateAlertButton: listType === "Alert",
        showLinkAsButton: true,
        title: (0,rich_text/* plainText */.K)(title)
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};
/* harmony default export */ const product_list = (ProductList);

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/shared/color-map.ts
var color_map = __webpack_require__(35241);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/slice/index.tsx + 1 modules
var slices_slice = __webpack_require__(23816);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/text/index.tsx
var slices_text = __webpack_require__(82072);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/text-text/styles.tsx
function text_text_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function text_text_styles_templateObject() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    text_text_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function text_text_styles_templateObject1() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  "
    ]);
    text_text_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function text_text_styles_templateObject2() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border-radius: ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    text_text_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function text_text_styles_templateObject3() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    padding-right: 0;\n    padding-bottom: ",
        ";\n  "
    ]);
    text_text_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function text_text_styles_templateObject4() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        ";\n"
    ]);
    text_text_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function text_text_styles_templateObject5() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    padding-left: 0;\n    padding-top: ",
        ";\n  "
    ]);
    text_text_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function text_text_styles_templateObject6() {
    var data = text_text_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  padding-left: ",
        ";\n\n  ",
        ";\n"
    ]);
    text_text_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var TextTextContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextTextContainer",
    componentId: "sc-0-0"
})(text_text_styles_templateObject2(), base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return "\n    background-color: ".concat(p.backgroundColor, ";\n  ");
}, base/* media.smallOnly */.BC.smallOnly(text_text_styles_templateObject()), base/* media.mediumUp */.BC.mediumUp(text_text_styles_templateObject1(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200));
var TextBefore = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "TextBefore",
    componentId: "sc-0-1"
})(text_text_styles_templateObject4(), function(p) {
    return p.width;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(text_text_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var TextAfter = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "TextAfter",
    componentId: "sc-0-2"
})(text_text_styles_templateObject6(), function(p) {
    return p.width;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(text_text_styles_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/text-text/index.tsx




var TextText = function(param) {
    var textBefore = param.textBefore, textAfter = param.textAfter, gridLayout = param.gridLayout, backgroundColor = param.backgroundColor;
    var colors = (0,color_map/* default */.Z)(backgroundColor);
    var width = grid_width(gridLayout);
    return /*#__PURE__*/ react.createElement(TextTextContainer, {
        backgroundColor: colors.bg,
        textColor: colors.text
    }, /*#__PURE__*/ react.createElement(TextBefore, {
        data: textBefore,
        width: width[0]
    }), /*#__PURE__*/ react.createElement(TextAfter, {
        data: textAfter,
        width: width[1]
    }));
};
/* harmony default export */ const text_text = (TextText);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/video/styles.ts
function video_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function video_styles_templateObject() {
    var data = video_styles_taggedTemplateLiteral([
        ""
    ]);
    video_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Video = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Video",
    componentId: "sc-0-0"
})(video_styles_templateObject());

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/video/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var video_Video = function(param) {
    var className = param.className, data = param.data;
    var videoRef = (0,react.useRef)(null);
    var SCALE = 1.78; // 16:9 video format
    var ref = _slicedToArray((0,react.useState)(0), 2), height = ref[0], setHeight = ref[1];
    (0,react.useEffect)(function() {
        var width = videoRef && videoRef.current && videoRef.current.offsetWidth || 0;
        setHeight(width / SCALE);
    }, []);
    var embedUrl = data.url.replace(/watch\?v=/, "embed/");
    return /*#__PURE__*/ react.createElement(Video, {
        ref: videoRef,
        className: className
    }, /*#__PURE__*/ react.createElement("iframe", {
        title: "video",
        width: "100%",
        height: height,
        src: embedUrl,
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    }));
};
/* harmony default export */ const video = (video_Video);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/video-text/styles.ts
function video_text_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function video_text_styles_templateObject() {
    var data = video_text_styles_taggedTemplateLiteral([
        "\n      flex-direction: column;\n    "
    ]);
    video_text_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function video_text_styles_templateObject1() {
    var data = video_text_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: ",
        ";\n\n    ",
        ";\n  "
    ]);
    video_text_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function video_text_styles_templateObject2() {
    var data = video_text_styles_taggedTemplateLiteral([
        "\n      width: 100%;\n      padding-left: 0;\n      padding-right: 0;\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n    "
    ]);
    video_text_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function video_text_styles_templateObject3() {
    var data = video_text_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    ",
        ";\n  "
    ]);
    video_text_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function video_text_styles_templateObject4() {
    var data = video_text_styles_taggedTemplateLiteral([
        "\n      width: 100%;\n      padding-left: 0;\n      padding-right: 0;\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n    "
    ]);
    video_text_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function video_text_styles_templateObject5() {
    var data = video_text_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n\n    ",
        ";\n  "
    ]);
    video_text_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var VideoText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoText",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(video_text_styles_templateObject1(), props.reverse ? "row" : "row-reverse", base/* media.smallOnly */.BC.smallOnly(video_text_styles_templateObject()));
});
var styles_Text = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(video_text_styles_templateObject3(), props.reverse ? props.width[0] : props.width[1], !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, base/* media.smallOnly */.BC.smallOnly(video_text_styles_templateObject2(), !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0));
});
var styles_Video = (0,styled_components_browser_esm["default"])(video).withConfig({
    displayName: "Video",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(video_text_styles_templateObject5(), props.reverse ? props.width[1] : props.width[0], props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, base/* media.smallOnly */.BC.smallOnly(video_text_styles_templateObject4(), props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0, !props.reverse ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0));
});

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/video-text/index.tsx



var video_text_VideoText = function(param) {
    var data = param.data, reverse = param.reverse;
    var width = grid_width(data.gridLayout);
    return /*#__PURE__*/ react.createElement(VideoText, {
        reverse: !!reverse
    }, /*#__PURE__*/ react.createElement(styles_Text, {
        data: data.text,
        width: width,
        reverse: !!reverse
    }), /*#__PURE__*/ react.createElement(styles_Video, {
        data: data.video,
        width: width,
        reverse: !!reverse
    }));
};
/* harmony default export */ const video_text = (video_text_VideoText);

// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(11093);
// EXTERNAL MODULE: ./src/areas/landing-page/components/front-page-banner/index.tsx + 1 modules
var front_page_banner = __webpack_require__(54069);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/article/index.tsx
function article_extends() {
    article_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return article_extends.apply(this, arguments);
}
























var getBackgroundColor = function(primary) {
    if ("heroBackgroundColor" in primary && primary.heroBackgroundColor) {
        return primary.heroBackgroundColor;
    }
    if ("backgroundColor" in primary) {
        return primary.backgroundColor;
    }
    if ("textColor" in primary) {
        return primary.textColor;
    }
    return null;
};
var Article = function(param) {
    var id = param.id, data = param.data, type = param.type;
    (0,react.useEffect)(function() {
        trackContentViewed(id);
        if (type === "CHANGELOG") {
            (0,tracking/* trackChangelogArticleViewed */.Bx)({
                id: id
            });
        }
    }, []);
    var renderSlice = function(slice, index) {
        var key = "".concat(slice.type, "_").concat(index);
        var backgroundColor = getBackgroundColor(slice.primary);
        var colors = (0,color_map/* default */.Z)(backgroundColor);
        var isWhiteBG = colors.bg === variables/* colors.lightTheme.base0 */.O9.lightTheme.base0;
        switch(slice.primary.__typename){
            case "PrismicSliceHeroTitle":
                return /*#__PURE__*/ react.createElement(hero, article_extends({
                    key: key
                }, slice.primary, {
                    textColor: colors.text,
                    heroBackgroundColor: colors.bg
                }));
            case "PrismicSliceText":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors,
                    isWhiteBG: isWhiteBG
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(slices_text/* default */.Z, article_extends({}, slice.primary))));
            case "PrismicSliceImage":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(slices_image, article_extends({}, slice.primary))));
            case "PrismicSliceImageText":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(image_text, article_extends({}, slice.primary))));
            case "PrismicSliceTextImage":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(image_text, article_extends({}, slice.primary, {
                    reverse: true
                }))));
            case "PrismicSliceTextText":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors,
                    isWhiteBG: isWhiteBG
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(text_text, article_extends({}, slice.primary))));
            case "PrismicSliceProduct":
                return slice.primary.product ? /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(product, article_extends({}, slice.primary)))) : null;
            case "PrismicSlicePopularProducts":
                return slice.primary.popularFacet ? /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(popular_products, article_extends({}, slice.primary)))) : null;
            case "PrismicSliceProductList":
                return slice.primary.products ? /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(product_list, article_extends({}, slice.primary)))) : null;
            case "PrismicSliceVideo":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(video, {
                    data: slice.primary.video
                })));
            case "PrismicSliceVideoText":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(video_text, {
                    data: slice.primary
                })));
            case "PrismicSliceTextVideo":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(video_text, {
                    reverse: true,
                    data: slice.primary
                })));
            case "PrismicSliceCallToAction":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(call_to_action, article_extends({}, slice.primary))));
            case "PrismicSliceFaqSection":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(faq/* default */.Z, article_extends({}, slice.primary))));
            case "PrismicSliceCategories":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(categories, article_extends({}, slice.primary))));
            case "PrismicSliceArticleCarousel":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(article_carousel, article_extends({}, slice.primary))));
            case "PrismicSliceColumns":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(columns, article_extends({}, slice.primary))));
            case "PrismicSliceNewsletter":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(newsletter, article_extends({}, slice.primary))));
            case "PrismicFrontPageBanner":
                return /*#__PURE__*/ react.createElement(slices_slice/* default */.Z, {
                    key: key,
                    colors: colors
                }, /*#__PURE__*/ react.createElement(PageContent, {
                    alignLeft: true
                }, /*#__PURE__*/ react.createElement(front_page_banner/* FrontPageBanner */.u, article_extends({}, slice.primary))));
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(ArticleComponent, null, data.body.map(renderSlice));
};
/* harmony default export */ const article = (/*#__PURE__*/(0,react.memo)(Article));

// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(98854);
// EXTERNAL MODULE: ./src/areas/editorial-content/query.graphql
var query_graphql = __webpack_require__(81474);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/editorial-content/queries/use-editorial-conent-page-query.ts


function useEditorialContentPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "editorialContent",
        variables: variables
    });
}

;// CONCATENATED MODULE: ./src/areas/editorial-content/editorial-content.tsx
function editorial_content_extends() {
    editorial_content_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return editorial_content_extends.apply(this, arguments);
}






var editorialContentTypes = [
    "EDITORIAL_CONTENT",
    "CHANGELOG",
    "INFO_PAGE",
    "TEST_TYPE"
];
var EditorialContentPage = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var pageQuery = useEditorialContentPageQuery(route === null || route === void 0 ? void 0 : route.variables);
    if (pageQuery.isLoading) {
        return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(loader/* default */.Z, null));
    }
    if (!pageQuery.isSuccess || !pageQuery.data.prismicArticle) {
        return null;
    }
    var dataFromArticle = pageQuery.data.prismicArticle;
    if (!dataFromArticle) return null;
    if (!editorialContentTypes.includes(dataFromArticle.type)) return null;
    return /*#__PURE__*/ react.createElement(article, editorial_content_extends({}, dataFromArticle));
};
/* harmony default export */ const editorial_content = (EditorialContentPage);


/***/ }),

/***/ 66467:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": () => (/* binding */ ExpertOfferListCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(69346);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/shop-link-card/index.tsx + 2 modules
var shop_link_card = __webpack_require__(502);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(27890);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(9160);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-offer-list-card/media/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  background: ",
        ";\n  border-radius: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  max-width: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ProductMedia = function(props) {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market;
    var lazyLoadImage = props.lazyLoadImage, imageSize = props.imageSize, imageSrc = props.imageSrc, name = props.name;
    var fallback = "".concat(market.cdn, "/product/standard/280/0.jpg");
    return lazyLoadImage ? /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        offset: 0,
        placeholder: /*#__PURE__*/ react.createElement(ImageSkeleton, {
            $size: "".concat(imageSize, "px")
        })
    }, /*#__PURE__*/ react.createElement(ProductImage, {
        src: imageSrc,
        name: name,
        fallback: fallback,
        $size: "".concat(imageSize, "px")
    })) : /*#__PURE__*/ react.createElement(ProductImage, {
        src: imageSrc,
        name: name,
        fallback: fallback,
        $size: "".concat(imageSize, "px")
    });
};
var ImageSkeleton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageSkeleton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.$size;
}, function(p) {
    return p.$size;
}, function(p) {
    return p.theme.bg.tertiary;
});
var ProductImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.$size;
});

// EXTERNAL MODULE: ./src/components/price-list/sort-by-price.ts
var sort_by_price = __webpack_require__(31780);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(26959);
// EXTERNAL MODULE: ./src/components/price-list/filtering.ts + 2 modules
var filtering = __webpack_require__(88257);
// EXTERNAL MODULE: ./src/components/price-list/filters-config.ts
var filters_config = __webpack_require__(87990);
// EXTERNAL MODULE: ./src/components/price-list/types.ts
var types = __webpack_require__(79126);
// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var product_condition_types = __webpack_require__(83071);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(82698);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33300);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/variants.js
var card_variants = __webpack_require__(84857);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(65208);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-offer-list-card/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: inherit;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: inherit;\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    position: relative;\n    height: fit-content;\n    width: ",
        ";\n    padding: 0;\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n    right: ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: auto;\n  align-self: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    align-items: center;\n    text-align: end;\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: auto;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: inherit;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n  min-height: 47px;\n  height: 47px;\n  justify-content: center;\n  color: ",
        ";\n\n  &::after {\n    ",
        "\n    border-radius: 5px;\n    pointer-events: none;\n    transition: background-color 150ms ease;\n  }\n\n  &:hover {\n    &::after {\n      background-color: rgba(0, 0, 0, 0.07);\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}






var Card = (0,styled_components_browser_esm["default"])(card_variants/* RowCard */.Jz).withConfig({
    displayName: "Card",
    componentId: "sc-0-0"
})(styles_templateObject());
var ActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "ActionArea",
    componentId: "sc-0-1"
})(styles_templateObject1());
var Main = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2()));
var ImageWrapper = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-3"
})(_templateObject4(), function(p) {
    return p.$size;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ColumnWrapper = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "ColumnWrapper",
    componentId: "sc-0-4"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StoresWrapper = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "StoresWrapper",
    componentId: "sc-0-5"
})(_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.smallOnly */.BC.smallOnly(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-7"
})(_templateObject9());
var CTAText = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "CTAText",
    componentId: "sc-0-8"
})(_templateObject10(), function(p) {
    return p.theme.icons.callToAction;
});
var CTAWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CTAWrapper",
    componentId: "sc-0-9"
})(_templateObject11());
var MissingPlaceHolder = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "MissingPlaceHolder",
    componentId: "sc-0-10"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.primary;
}, base/* styledUtils.overlay */.au.overlay());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-offer-list-card/index.tsx

















var MAX_VISIBLE_OFFERS = 3;
var ExpertOfferListCard = function(props) {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var className = props.className, dataTest = props["data-test"], id = props.id, imageSrc = props.imageSrc, _imageSize = props.imageSize, imageSize = _imageSize === void 0 ? 140 : _imageSize, name = props.name, link = props.link, reviewsCount = props.reviewsCount, rating = props.rating, prices = props.prices, campaignProducts = props.campaignProducts, onClick = props.onClick;
    // Filtering out all offers that aren't displayed initially on the product page
    // because they are hidden by filters
    var initialFilters = (0,filters_config/* getFiltersConfig */.I)();
    var filteredOffers = (0,filtering/* filterOffers */.h)(initialFilters, prices).filter(function(offer) {
        return offer.condition === product_condition_types/* ConditionEnum.NEW */.M.NEW;
    });
    var getSortedOffers = function() {
        // Should include offers with unfeatured shops, but sort them last.
        var firstSort = (0,sort_by_price/* sortOffersByPrice */.bo)(types/* PriceDisplayEnum.PRICE */.wB.PRICE, filteredOffers);
        var sortByFeaturedShop = (0,sort_by_price/* genericSort */.Cv)(firstSort, {
            resolver: function(offer) {
                return offer.featured || 0;
            },
            sortDirection: sort_by_price/* SortDirection.Descending */.Sr.Descending
        });
        return sortByFeaturedShop;
    };
    var sortedOffers = getSortedOffers();
    var availableOffers = sortedOffers.filter(function(offer) {
        var ref;
        return ((ref = offer.availability) === null || ref === void 0 ? void 0 : ref.condition) !== "NotAvailableForOrder";
    });
    var slicedPrices = availableOffers.slice(0, MAX_VISIBLE_OFFERS);
    var campaigns = campaignProducts ? Object.values(campaignProducts) : [];
    return /*#__PURE__*/ react.createElement(Card, {
        className: className,
        containerProps: {
            "data-test": "".concat(dataTest),
            onClick: onClick
        }
    }, market.login.enabled && /*#__PURE__*/ react.createElement(IconWrapper, null, id && name && /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
        dropdownGrow: isMobile ? "left" : "right",
        productId: id,
        productName: name,
        tooltipPlacement: isMobile ? ui/* Direction.Left */.Nm.Left : ui/* Direction.Right */.Nm.Right
    })), /*#__PURE__*/ react.createElement(Main, null, /*#__PURE__*/ react.createElement(ColumnWrapper, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: link
        },
        style: {
            flexDirection: "column",
            alignItems: "center"
        }
    }, /*#__PURE__*/ react.createElement(ImageWrapper, {
        $size: "".concat(imageSize, "px")
    }, /*#__PURE__*/ react.createElement(ProductMedia, {
        imageSrc: imageSrc,
        imageSize: imageSize,
        lazyLoadImage: true,
        name: name || ""
    })), rating && rating > 0 ? /*#__PURE__*/ react.createElement(RatingWrapper, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounter: true,
        showCounterAs: "number",
        showRate: true,
        showRateAs: "number"
    })) : null), /*#__PURE__*/ react.createElement(StoresWrapper, null, prices && slicedPrices && slicedPrices.length ? slicedPrices.map(function(data) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        return id && (data === null || data === void 0 ? void 0 : data.id) && /*#__PURE__*/ react.createElement(shop_link_card/* ShopLinkCard */.E, {
            key: (ref = data.store) === null || ref === void 0 ? void 0 : ref.id,
            "data-test": "ExpertStoreCard",
            id: (ref1 = data.store) === null || ref1 === void 0 ? void 0 : ref1.id,
            name: (ref2 = data.store) === null || ref2 === void 0 ? void 0 : ref2.name,
            logoUrl: (ref3 = data.store) === null || ref3 === void 0 ? void 0 : ref3.logo,
            pathname: data.externalUri || "",
            hasLogo: (ref4 = data.store) === null || ref4 === void 0 ? void 0 : ref4.hasLogo,
            featured: (ref5 = data.store) === null || ref5 === void 0 ? void 0 : ref5.featured,
            logoWidth: 176,
            rating: (ref6 = data.store) === null || ref6 === void 0 ? void 0 : ref6.userReviewSummary.rating,
            reviewCount: (ref7 = data.store) === null || ref7 === void 0 ? void 0 : ref7.userReviewSummary.count,
            renderMode: "native",
            price: (ref8 = data.price) === null || ref8 === void 0 ? void 0 : ref8.exclShipping,
            stockStatus: (ref9 = data.stock) === null || ref9 === void 0 ? void 0 : ref9.status,
            numericRating: true,
            productId: id,
            priceId: data.id,
            isDeal: campaignProducts ? campaigns.some(function(campaign) {
                return (campaign === null || campaign === void 0 ? void 0 : campaign.priceId) === Number(data.id);
            }) : false
        });
    }) : /*#__PURE__*/ react.createElement(MissingPlaceHolder, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("expert", "offers.missing-retailers"))), /*#__PURE__*/ react.createElement(ActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: link
        }
    }, /*#__PURE__*/ react.createElement(CTAText, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.PRIMARY,
        containerProps: {
            "data-test": "".concat(dataTest, "-cta")
        }
    }, slicedPrices.length ? t("category", "product-offer.cta", {
        n: sortedOffers.length
    }) : t("expert", "offers.view-product-page")), /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
        color: "maybeBlue700"
    }))))));
};


/***/ }),

/***/ 23599:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "Gh": () => (/* binding */ FilterContainer),
/* harmony export */   "QE": () => (/* binding */ Subtitle),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "YE": () => (/* binding */ Sidebar),
/* harmony export */   "ck": () => (/* binding */ Item),
/* harmony export */   "d2": () => (/* binding */ Article),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "jQ": () => (/* binding */ MediaImage),
/* harmony export */   "ll": () => (/* binding */ CardTitle),
/* harmony export */   "or": () => (/* binding */ Main),
/* harmony export */   "pU": () => (/* binding */ Media),
/* harmony export */   "zB": () => (/* binding */ MediaWrapper)
/* harmony export */ });
/* unused harmony exports AVATAR_SIZE, Info, ContentType */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69346);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  a {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-columns: minmax(0, 1fr);\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &&,\n  > * {\n    font-size: ",
        ";\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      padding-right: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        ";\n    flex-shrink: 0;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-auto-flow: row;\n  padding: ",
        " 0;\n  row-gap: ",
        ";\n  height: max-content;\n\n  h1 {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n\n      &:not(:first-of-type) {\n        margin-top: ",
        ";\n      }\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    display: grid;\n    grid-auto-flow: row;\n    row-gap: ",
        ";\n    order: 2;\n    margin-top: ",
        ";\n\n    a:not([class]) {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n        text-decoration: underline;\n      }\n    }\n\n    ",
        ";\n\n    > h2,\n    > h3,\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  align-items: center;\n  justify-content: start;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 8px;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    margin: ",
        " 0;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  margin: ",
        " 0;\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow-x: auto;\n  padding: 2px;\n\n  > button {\n    flex-shrink: 0;\n    margin-bottom: ",
        ";\n\n    :not(:last-child) {\n      margin-right: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}



var AVATAR_SIZE = 32;
var CardTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "CardTitle",
    componentId: "sc-0-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject1()));
var Main = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].main.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3());
var Article = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].article.withConfig({
    displayName: "Article",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "Title",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var Sidebar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].aside.withConfig({
    displayName: "Sidebar",
    componentId: "sc-0-6"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject8(), p.viewport === "desktop" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7())), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.viewport === "mobile" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9())));
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].header.withConfig({
    displayName: "Header",
    componentId: "sc-0-7"
})(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var _marginTop;
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-8"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), p.fontSize || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, p.rowGap || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, (_marginTop = p.marginTop) !== null && _marginTop !== void 0 ? _marginTop : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.callToAction, p.theme.text.callToActionHover, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject14(), p.order || 2, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
});
var Info = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Info",
    componentId: "sc-0-9"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Subtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-10"
})(_templateObject17());
var MediaWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MediaWrapper",
    componentId: "sc-0-11"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), props.maxWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), props.maxWidth));
});
var Media = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-12"
})(_templateObject20());
var MediaImage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "MediaImage",
    componentId: "sc-0-13"
})(_templateObject22(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject21()));
var ContentType = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ContentType",
    componentId: "sc-0-14"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.secondary;
});
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].hr.withConfig({
    displayName: "Divider",
    componentId: "sc-0-15"
})(_templateObject25(), function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing300 */ .bK.measurements.spacing300, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
var FilterContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterContainer",
    componentId: "sc-0-16"
})(_templateObject26(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 10662:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ featured_article)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/featured-article/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding-top: 4px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-right: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n\n  /* Add extra spacing to panel header which has 12px - Should be 24 in desktop and 16 on mobile */\n  padding-top: 12px;\n  ",
        ";\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n\n    > span {\n      flex-grow: 0;\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    flex-basis: 60%;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    flex-basis: 40%;\n    max-width: 300px;\n    padding-right: ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  position: relative;\n  min-height: 170px;\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var FeaturedArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FeaturedArticle",
    componentId: "sc-0-0"
})(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject()), base/* media.mediumUp */.BC.mediumUp(_templateObject1()), base/* media.showOutsiderAd */.BC.showOutsiderAd(_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var ArticleLink = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "ArticleLink",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.smallOnly */.BC.smallOnly(_templateObject4()));
var TextContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextContainer",
    componentId: "sc-0-2"
})(_templateObject7(), base/* media.mediumUp */.BC.mediumUp(_templateObject6()));
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-3"
})(_templateObject10(), base/* media.smallOnly */.BC.smallOnly(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.mediumUp */.BC.mediumUp(_templateObject9(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/featured-article/index.tsx





var featured_article_FeaturedArticle = function(param) {
    var className = param.className, imageUrl = param.imageUrl, pathName = param.pathName, preamble = param.preamble, title = param.title, linkText = param.linkText;
    var renderArticleLink = function() {
        if (!linkText) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(ArticleLink, {
            container: "a",
            containerProps: {
                href: pathName
            },
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.ARTICLE_READ_MORE */.U.ARTICLE_READ_MORE,
                    nextPage: pathName
                });
            }
        }, linkText);
    };
    return /*#__PURE__*/ react.createElement(FeaturedArticle, {
        className: className
    }, imageUrl && /*#__PURE__*/ react.createElement(ImageWrapper, null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.ARTICLE_CONTENT_CARD */.U.ARTICLE_CONTENT_CARD,
                nextPage: pathName
            });
        }
    }, /*#__PURE__*/ react.createElement("img", {
        src: imageUrl,
        alt: ""
    })))), /*#__PURE__*/ react.createElement(TextContainer, null, /*#__PURE__*/ react.createElement("h3", null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName
    }, title)), /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.ARTICLE_READ_MORE */.U.ARTICLE_READ_MORE,
                nextPage: pathName
            });
        }
    }, /*#__PURE__*/ react.createElement("p", null, preamble)), renderArticleLink()));
};
/* harmony default export */ const featured_article = (featured_article_FeaturedArticle);


/***/ }),

/***/ 54069:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* binding */ FrontPageBanner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71309);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33300);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(76891);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(69346);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/front-page-banner/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  & > h1 {\n    margin-bottom: 0;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 304px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 440px;\n  font-size: ",
        ";\n  line-height: 24px;\n  text-align: center;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 304px;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    max-height: 236px;\n    margin: auto;\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 980px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: center;\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  & {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var Title = (0,styled_components_browser_esm["default"])(rich_text/* default */.Z).withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(_templateObject());
var SubTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "SubTitle",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge, base/* media.smallOnly */.BC.smallOnly(_templateObject1()));
var Button = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-2"
})(_templateObject3());
var Banner = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "Banner",
    componentId: "sc-0-3"
})(_templateObject5(), base/* media.smallOnly */.BC.smallOnly(_templateObject4(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200));
var TextButton = (0,styled_components_browser_esm["default"])(variants.ButtonText).withConfig({
    displayName: "TextButton",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), text_variants.FontWeight.HEAVIER, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, props.fontColor);
});
var BackgroundImage = (0,styled_components_browser_esm["default"])(card.CardBackgroundImage).withConfig({
    displayName: "BackgroundImage",
    componentId: "sc-0-5"
})(_templateObject7());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/shared/color-map.ts
var color_map = __webpack_require__(35241);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/front-page-banner/index.tsx







var FrontPageBanner = function(param) {
    var image = param.image, link = param.link, buttonText = param.buttonText, title = param.title, subtitle = param.subtitle, buttonColor = param.buttonColor, textColor = param.textColor;
    var isExternal = link === null || link === void 0 ? void 0 : link.startsWith("http");
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var fontColor = (0,color_map/* default */.Z)(textColor);
    var subtitleText = (0,rich_text/* plainText */.K)(subtitle);
    return /*#__PURE__*/ react.createElement(Banner, null, /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: !isMobile ? clickable/* Clickable */.P : undefined,
        containerProps: {
            to: link,
            isExternal: isExternal
        }
    }, /*#__PURE__*/ react.createElement(BackgroundImage, {
        src: image.url
    }, /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Title, {
        data: title
    }), /*#__PURE__*/ react.createElement(SubTitle, null, subtitleText), /*#__PURE__*/ react.createElement(Button, {
        container: isMobile ? clickable/* Clickable */.P : undefined,
        containerProps: {
            to: link,
            isExternal: isExternal
        },
        style: {
            background: buttonColor
        }
    }, /*#__PURE__*/ react.createElement(TextButton, {
        fontColor: fontColor.text
    }, buttonText))))));
};


/***/ }),

/***/ 89647:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ FeaturedArticle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-group/index.js + 1 modules
var campaign_group = __webpack_require__(53501);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33300);
;// CONCATENATED MODULE: ./src/components/featured-article/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n    padding-right: ",
        ";\n    flex: 1 0 70%;\n      max-width: 70%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 0 640px;\n    max-width: 640px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  flex: 1 0 100%;\n  max-width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      flex: 1 0 100%;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 100%;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin-bottom: 1rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 185px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StyledArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-0"
})(_templateObject2(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300, base/* media.mediumUp */.BC.mediumUp(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* media.largeUp */.BC.largeUp(_templateObject1()));
var RelatedArticleContainer = styled_components_browser_esm["default"].section.withConfig({
    displayName: "RelatedArticleContainer",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject3()), function(p) {
    return p.fullWidth && (0,styled_components_browser_esm.css)(_templateObject4());
});
var StyledFeaturedArticle = styled_components_browser_esm["default"].section.withConfig({
    displayName: "StyledFeaturedArticle",
    componentId: "sc-0-2"
})(_templateObject6(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300);
var RelatedArticleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedArticleWrapper",
    componentId: "sc-0-3"
})(_templateObject7());
var StyledCardMedia = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "StyledCardMedia",
    componentId: "sc-0-4"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/article/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: 1.2rem;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.6rem;\n  line-height: 1.4;\n  margin: 0 0 1rem;\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    h4 {margin-bottom: 1.4rem;}\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  color: ",
        ";\n\n  figure {\n    margin-bottom: 1rem;\n    img {\n      display: block;\n      margin: 0 auto;\n      max-width: 100%;\n    }\n    figcaption {\n      color: ",
        ";\n      text-align: right;\n    }\n  }\n  ",
        " {\n    font-size: 1.6rem;\n  }\n  h2 {\n    font-size: 1.3rem;\n  }\n  h3 {\n    font-size: 1.15rem;\n  }\n  h4 {\n    margin-bottom: 1rem;\n  }\n  ol,\n  ul {\n    list-style-position: inside;\n    line-height: 1.6;\n  }\n  p {\n    line-height: 1.6;\n  }\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n  .caption {\n    text-align: right;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  font-weight: 600;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledArticleHeading = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "StyledArticleHeading",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var styles_StyledArticle = styled_components_browser_esm["default"].article.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-1"
})(styles_templateObject3(), function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.text.secondary;
}, StyledArticleHeading, function(p) {
    return p.theme.text.linkExternal;
}, base/* media.largeUp */.BC.largeUp(styles_templateObject2()));
var Preamble = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Preamble",
    componentId: "sc-0-2"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/components/article/article-heading.tsx


var ArticleHeading = function(param) {
    var title = param.title, _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    return embedded ? /*#__PURE__*/ react.createElement(StyledArticleHeading, {
        as: "h2"
    }, title) : /*#__PURE__*/ react.createElement(StyledArticleHeading, null, title);
};

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
;// CONCATENATED MODULE: ./src/components/article/article.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Article = function(_param) {
    var _embedded = _param.embedded, embedded = _embedded === void 0 ? true : _embedded, props = _objectWithoutProperties(_param, [
        "embedded"
    ]);
    return /*#__PURE__*/ react.createElement(styles_StyledArticle, null, props.imageUrl && /*#__PURE__*/ react.createElement("figure", null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        src: props.imageUrl,
        alt: props.imageCaption || ""
    })), props.imageCaption && /*#__PURE__*/ react.createElement("figcaption", null, props.imageCaption)), /*#__PURE__*/ react.createElement(ArticleHeading, {
        title: props.title,
        embedded: embedded
    }), props.preamble && /*#__PURE__*/ react.createElement(Preamble, null, props.preamble), props.body && /*#__PURE__*/ react.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: props.body
        }
    }), props.byline && /*#__PURE__*/ react.createElement("span", null, props.byline));
};

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/areas/expert/styles.ts
var styles = __webpack_require__(23599);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(69346);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/featured-article/related-article.tsx








var RelatedArticle = function(param) {
    var article = param.article, _preambleMaxLength = param.preambleMaxLength, preambleMaxLength = _preambleMaxLength === void 0 ? 80 : _preambleMaxLength;
    return /*#__PURE__*/ react.createElement(card.Card, null, /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: article.pathName,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.RELATED_ARTICLE */.U.RELATED_ARTICLE,
                    nextPage: article.pathName
                });
            }
        }
    }, article.imageUrl && /*#__PURE__*/ react.createElement(StyledCardMedia, null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        alt: article.title,
        src: article.imageUrl,
        height: 124
    }))), /*#__PURE__*/ react.createElement(card.CardContent, null, /*#__PURE__*/ react.createElement(styles/* CardTitle */.ll, null, article.title), article.preamble && /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        container: "p"
    }, formatPreamble(article.preamble, preambleMaxLength)))));
};
function formatPreamble(str, maxLength) {
    return str && str.length > maxLength ? "".concat(str.substr(0, str.substr(0, maxLength).lastIndexOf(" ")).trim(), "\xa0…") : str;
}

;// CONCATENATED MODULE: ./src/components/featured-article/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var FeaturedArticle = function(param) {
    var article = param.article, _embedded = param.embedded, embedded = _embedded === void 0 ? true : _embedded, _related = param.related, related = _related === void 0 ? [] : _related;
    var ref;
    var articleId = article ? article.id : null;
    var relatedArticles = (article && article.related && article.related.articles ? related.concat(article.related.articles) : related).filter(Boolean).filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== articleId;
    }).sort(function(a, b) {
        return new Date((b === null || b === void 0 ? void 0 : b.publishedAt) || "1971-1-1").getTime() - new Date((a === null || a === void 0 ? void 0 : a.publishedAt) || "1971-1-1").getTime();
    });
    return /*#__PURE__*/ react.createElement(StyledFeaturedArticle, null, !!article && /*#__PURE__*/ react.createElement(StyledArticle, null, /*#__PURE__*/ react.createElement(Article, _extends({}, article, {
        embedded: embedded
    }))), /*#__PURE__*/ react.createElement(RelatedArticleContainer, {
        fullWidth: !article
    }, /*#__PURE__*/ react.createElement(RelatedArticleWrapper, null, relatedArticles.map(function(item) {
        return /*#__PURE__*/ react.createElement(RelatedArticle, {
            key: item.id,
            article: item
        });
    })), (article === null || article === void 0 ? void 0 : (ref = article.related) === null || ref === void 0 ? void 0 : ref.campaign) && /*#__PURE__*/ react.createElement(campaign_group/* default */.Z, {
        campaigns: [
            article.related.campaign
        ]
    })));
};


/***/ }),

/***/ 56710:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ NumberPagination)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-items.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function notNull(item) {
    return item !== null;
}
function getPrevPageItem(currentPage, alwaysShowStepButtons) {
    if (currentPage === 1 && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "prev",
        pageNumber: currentPage - 1,
        disabled: currentPage === 1
    };
}
function getFirstPageItem(nearbyPages) {
    var _Math;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    if (firstNearbyPage === 1) {
        return null;
    }
    return {
        type: "first",
        pageNumber: 1,
        indicateOmittedPages: firstNearbyPage > 2 ? "after" : undefined
    };
}
function getNearbyPages(currentPage, totalPages) {
    var from = Math.max(1, Math.min(totalPages - 4, currentPage - 2));
    var to = Math.min(totalPages, Math.max(5, currentPage + 2));
    var pages = [];
    for(var i = from; i <= to; i += 1){
        var page = {
            type: "nearby-page",
            pageNumber: i,
            isCurrent: currentPage === i
        };
        if ([
            from,
            to
        ].includes(i) && !page.isCurrent) {
            page.omitOnSmallDevices = true;
        }
        pages.push(page);
    }
    return pages;
}
var getMidrangePage = function(position, nearbyPages, totalPages) {
    var _Math, _Math1;
    var threshold = 5;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    var lastNearByPage = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(nearbyPages));
    switch(position){
        case "before":
            if (firstNearbyPage < threshold) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.ceil(firstNearbyPage / 2),
                indicateOmittedPages: "after"
            };
        case "after":
            if (lastNearByPage + threshold > totalPages) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.floor((totalPages - lastNearByPage) / 2) + lastNearByPage,
                indicateOmittedPages: "before"
            };
        default:
            return null;
    }
};
function getLastPageItem(nearbyPages, totalPages) {
    var _Math;
    var lastNearbyPage = (_Math = Math).max.apply(_Math, _toConsumableArray(nearbyPages));
    if (lastNearbyPage === totalPages) {
        return null;
    }
    return {
        type: "last",
        pageNumber: totalPages,
        indicateOmittedPages: lastNearbyPage < totalPages - 1 ? "before" : undefined
    };
}
function getNextPageItem(currentPage, totalPages, alwaysShowStepButtons) {
    if (currentPage === totalPages && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "next",
        pageNumber: currentPage + 1,
        disabled: currentPage === totalPages
    };
}
function getPaginationItems(currentPage, totalPages) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _alwaysShowStepButtons = ref.alwaysShowStepButtons, alwaysShowStepButtons = _alwaysShowStepButtons === void 0 ? false : _alwaysShowStepButtons;
    if (totalPages <= 1) {
        return [];
    }
    var clampedCurrentPage = Math.max(1, Math.min(totalPages, currentPage));
    var nearbyPages = getNearbyPages(clampedCurrentPage, totalPages);
    var nearbyPageNrs = nearbyPages.map(function(page) {
        return page.pageNumber;
    });
    return [
        getPrevPageItem(clampedCurrentPage, alwaysShowStepButtons),
        getFirstPageItem(nearbyPageNrs),
        getMidrangePage("before", nearbyPageNrs, totalPages)
    ].concat(_toConsumableArray(nearbyPages), [
        getMidrangePage("after", nearbyPageNrs, totalPages),
        getLastPageItem(nearbyPageNrs, totalPages),
        getNextPageItem(clampedCurrentPage, totalPages, alwaysShowStepButtons)
    ]).filter(notNull);
}

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
;// CONCATENATED MODULE: ./src/components/number-pagination/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    ",
        "\n\n    @media screen and (max-width: 420px) {\n      ",
        "\n\n      @media screen and (max-width: 350px) {\n        margin: 0 ",
        " 0 0;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-weight: 600;\n  height: 30px;\n  justify-content: center;\n  min-width: 30px;\n  padding: ",
        ";\n  transition: all ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background: ",
        ";\n  color: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var measurements = base/* layout.measurements */.bK.measurements, animations = base/* layout.animations */.bK.animations;
var Pagination = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Pagination",
    componentId: "sc-0-0"
})(_templateObject());
var PaginationListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaginationListItem",
    componentId: "sc-0-1"
})(function(param) {
    var indicateOmittedPages = param.indicateOmittedPages, omitOnSmallDevices = param.omitOnSmallDevices;
    return (0,styled_components_browser_esm.css)(_templateObject2(), indicateOmittedPages === "before" ? measurements.spacing150 : 0, indicateOmittedPages === "after" ? measurements.spacing150 : measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), indicateOmittedPages === "before" ? measurements.spacing050 : 0, indicateOmittedPages === "after" ? measurements.spacing050 : measurements.spacing025), omitOnSmallDevices ? "display: none;" : "", measurements.spacing025);
});
var paginationLinkStyles = (0,styled_components_browser_esm.css)(_templateObject4(), measurements.spacing050, animations.buttonTransition, base/* media.smallOnly */.BC.smallOnly(_templateObject3(), measurements.spacing025));
var PaginationLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "PaginationLink",
    componentId: "sc-0-2"
})(_templateObject5(), paginationLinkStyles, function(props) {
    return props.theme.colors.base800;
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return "transparent 0px 0px ".concat(props.theme.colors.base800, " 0px 0px 0px 1px");
});
var DisabledPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DisabledPaginationLink",
    componentId: "sc-0-3"
})(_templateObject6(), paginationLinkStyles, function(props) {
    return "inset 0 0 0 1px ".concat(props.theme.lines.primary);
}, function(props) {
    return props.theme.text.quaternary;
}, function(props) {
    return props.theme.bg.secondary;
});
var CurrentPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPaginationLink",
    componentId: "sc-0-4"
})(_templateObject7(), paginationLinkStyles, function(props) {
    return props.theme.colors.maybeBlue500;
}, function(props) {
    return props.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(98841);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(26959);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-item.tsx





var PaginationItem = function(param) {
    var item = param.item, linkToPage = param.linkToPage, onClick = param.onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var label = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null);
            case "next":
                return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null);
            default:
                return /*#__PURE__*/ react.createElement(react.Fragment, null, item.pageNumber);
        }
    }, [
        item.type,
        item.pageNumber
    ]);
    var ariaLabel = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return t("symbols", "symbol.show-prev");
            case "next":
                return t("symbols", "symbol.show-next");
            default:
                return t("common", "pagination.page-number", {
                    number: item.pageNumber
                });
        }
    }, [
        item.type,
        item.pageNumber,
        t
    ]);
    var onClickHandler = (0,react.useCallback)(function() {
        return typeof onClick === "function" && onClick(item);
    }, [
        item,
        onClick
    ]);
    if (item.disabled) {
        return /*#__PURE__*/ react.createElement(DisabledPaginationLink, null, label);
    }
    if (item.isCurrent) {
        return /*#__PURE__*/ react.createElement(CurrentPaginationLink, {
            "data-test": "CurrentPaginationLink"
        }, label);
    }
    return /*#__PURE__*/ react.createElement(PaginationLink, {
        to: linkToPage(item.pageNumber),
        "data-test": "PaginationLink",
        "data-test-page": item.pageNumber,
        onClick: onClickHandler,
        "aria-label": ariaLabel
    }, label);
};
/* harmony default export */ const pagination_item = (PaginationItem);

;// CONCATENATED MODULE: ./src/components/number-pagination/index.tsx




var NumberPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, linkToPage = param.linkToPage, onClick = param.onClick, alwaysShowStepButtons = param.alwaysShowStepButtons;
    var paginationItems = (0,react.useMemo)(function() {
        return getPaginationItems(currentPage, totalPages, {
            alwaysShowStepButtons: alwaysShowStepButtons
        });
    }, [
        currentPage,
        totalPages,
        alwaysShowStepButtons
    ]);
    return /*#__PURE__*/ react.createElement(Pagination, {
        "data-test": "Pagination"
    }, paginationItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(PaginationListItem, {
            key: "".concat(item.type, ":").concat(item.pageNumber),
            indicateOmittedPages: item.indicateOmittedPages,
            omitOnSmallDevices: item.omitOnSmallDevices
        }, /*#__PURE__*/ react.createElement(pagination_item, {
            item: item,
            linkToPage: linkToPage,
            onClick: onClick
        }));
    }));
};


/***/ }),

/***/ 502:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ShopLinkCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(74233);
// EXTERNAL MODULE: ./src/components/product-card-old/components/price.tsx
var components_price = __webpack_require__(25653);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(19247);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
;// CONCATENATED MODULE: ./src/components/shop-link-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: inherit;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  padding: ",
        ";\n  min-height: 47px;\n\n  &::after {\n    ",
        "\n    border-radius: 5px;\n    pointer-events: none;\n    transition: background-color 150ms ease;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n\n  &:hover {\n    &::after {\n      background-color: rgba(0, 0, 0, 0.07);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  min-width: 90px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  margin-left: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(59, 163, 212, 1);\n  box-shadow: 0px 2px 4px rgba(5, 37, 46, 0.24);\n  border-radius: ",
        ";\n  margin-left: ",
        ";\n  margin-top: -",
        ";\n  margin-bottom: -",
        ";\n  width: 36px;\n  height: 36px;\n\n  :hover {\n    cursor: pointer;\n  }\n\n  svg {\n    fill: rgba(255, 255, 255, 1);\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var BUTTON_MARGIN_UNFEATURED = 52;
var BUTTON_MARGIN_UNFEATURED_MOBILE = 44;
var sharedStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* styledUtils.overlay */.au.overlay());
var StoreLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StoreLink",
    componentId: "sc-0-0"
})(_templateObject1(), sharedStyles);
var UnfeaturedStore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UnfeaturedStore",
    componentId: "sc-0-1"
})(_templateObject2(), sharedStyles);
var Logo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Count = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Count",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.quaternary;
});
var PriceInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInformation",
    componentId: "sc-0-4"
})(_templateObject5());
var PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceWrapper",
    componentId: "sc-0-5"
})(_templateObject7(), function(p) {
    return !p.$featured ? "".concat(BUTTON_MARGIN_UNFEATURED, "px") : "0";
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), function(p) {
    return !p.$featured ? "".concat(BUTTON_MARGIN_UNFEATURED_MOBILE, "px") : "-".concat(base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
}));
var OfferButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "OfferButton",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var RatingText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-7"
})(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.23.7_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(26959);
;// CONCATENATED MODULE: ./src/components/shop-link-card/components/price-information/index.tsx





var price_information_PriceInformation = function(props) {
    var price = props.price, stockStatus = props.stockStatus, isDeal = props.isDeal, featured = props.featured;
    return /*#__PURE__*/ react.createElement(PriceInformation, null, /*#__PURE__*/ react.createElement(stock_status/* StockStatus */.B, {
        status: stockStatus || undefined
    }), /*#__PURE__*/ react.createElement(PriceWrapper, {
        $featured: featured
    }, /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        isDeal: isDeal
    })), featured && /*#__PURE__*/ react.createElement(OfferButton, null, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
        color: "base0"
    })));
};

// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(36483);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/utils.ts
var utils = __webpack_require__(91682);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts
var conversion = __webpack_require__(1043);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(46626);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx + 1 modules
var rating_icon = __webpack_require__(6511);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/utils.ts
var smiley_rating_utils = __webpack_require__(1013);
;// CONCATENATED MODULE: ./src/components/shop-link-card/index.tsx












var ShopLinkCard = function(props) {
    var id = props.id, dataTest = props["data-test"], name = props.name, hasLogo = props.hasLogo, logoUrl = props.logoUrl, logoWidth = props.logoWidth, featured = props.featured, pathname = props.pathname, rating = props.rating, _numericRating = props.numericRating, numericRating = _numericRating === void 0 ? false : _numericRating, reviewCount = props.reviewCount, renderMode = props.renderMode, stockStatus = props.stockStatus, price = props.price, productId = props.productId, priceId = props.priceId, _isDeal = props.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, _clickTrackingScope = props.// Use this as default since this component originally was refactored out
    // from src/components/user-review-card
    clickTrackingScope, clickTrackingScope = _clickTrackingScope === void 0 ? conversion/* TrackClickScope.USER_REVIEW_CARD */.b8.USER_REVIEW_CARD : _clickTrackingScope;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var count = reviewCount && reviewCount > 500 ? "500+" : reviewCount;
    var highResolutionLogo = logoUrl ? {
        url: logoUrl,
        width: logoWidth
    } : null;
    var featuredStore = Boolean(featured);
    var rate = rating_helper/* default.convert */.Z.convert(rating || 0);
    var smileyRating = (0,smiley_rating_utils/* getSmileyRating */.P)(rate.real);
    var ratingType = numericRating ? rate.rounded : t("reviews", smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text);
    var trackClickOut = function() {
        if (!priceId || !productId) {
            return;
        }
        // Track revenue and event on click out
        (0,utils/* logRevenueEvent */.mb)(String(priceId), productId);
        dispatch((0,product/* productPriceClick */.Po)(productId, price, featuredStore, "", false, "StoreCard"));
        (0,conversion/* trackOfferClickWithRevenue */.Rx)({
            scope: clickTrackingScope,
            priceId: priceId,
            productId: productId
        });
    };
    var renderContent = function() {
        /*#__PURE__*/ return react.createElement(react.Fragment, null, id && name && /*#__PURE__*/ react.createElement(Logo, {
            storeId: id,
            name: name,
            hasImage: Boolean(hasLogo),
            featured: featuredStore,
            logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
            width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width,
            showHighResolutionLogo: Boolean(highResolutionLogo)
        }), rating && rating !== 0 && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.iconType) && (smileyRating === null || smileyRating === void 0 ? void 0 : smileyRating.text) ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
            type: smileyRating.iconType,
            disabled: !featuredStore,
            ariaLabel: ratingType.toString()
        }), numericRating ? /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(RatingText, null, ratingType)) : /*#__PURE__*/ react.createElement(RatingText, null, ratingType), price ? /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(Count, null, "(", count, ")")) : /*#__PURE__*/ react.createElement(Count, null, "(", count, ")")) : null, price && /*#__PURE__*/ react.createElement(price_information_PriceInformation, {
            price: price,
            stockStatus: stockStatus,
            isDeal: isDeal,
            featured: featuredStore
        }));
    };
    if (!pathname) {
        return /*#__PURE__*/ react.createElement(UnfeaturedStore, null, renderContent());
    }
    return /*#__PURE__*/ react.createElement(StoreLink, {
        "data-test": dataTest,
        onClick: trackClickOut,
        to: pathname,
        isExternal: renderMode === "native",
        target: "_blank"
    }, renderContent());
};


/***/ })

}]);